/** @jsxImportSource @emotion/react */
import { css, useTheme } from '@emotion/react';
import axios from 'axios';
import { useEffect, useState, useContext } from 'react';
import { AuthContext } from '../contexts/AuthContext';
import { ImSpinner3 } from 'react-icons/im';
import AudioPlayer from 'react-h5-audio-player';
import 'react-h5-audio-player/lib/styles.css';
import { IoIosPlayCircle } from 'react-icons/io';
import { IoIosPause } from 'react-icons/io';
import { IoIosRewind } from 'react-icons/io';
import { IoIosFastforward } from 'react-icons/io';
import { TiArrowLoop } from 'react-icons/ti';
import { ImVolumeHigh } from 'react-icons/im';
import { HiVolumeOff } from 'react-icons/hi';

const PlayerElement = ({ id }) => {
	const { authToken } = useContext(AuthContext);
	const [player, setPlayer] = useState();

	useEffect(() => {
		if (id) {
			axios(`https://api.spotify.com/v1/tracks/${id}`, {
				headers: {
					Authorization: 'Bearer ' + authToken.access_token,
				},
			}).then((result) => setPlayer(result.data.album));
		}
	}, [id, authToken]);

	const theme = useTheme();

	const playerImg = css`
		width: 60%;
		position: absolute;
		margin: 85px 20%;
	`;

	const playerInfo = css`
		text-align: center;
	`;

	const playerName = css`
		font-size: 20px;
		font-weight: bold;
		margin: 0;
		padding-bottom: 5px;
	`;

	const playerArtist = css`
		font-size: 15px;
		font-weight: 300;
		margin: 0;
		padding-top: 5px;
	`;

	const audioPlayer = css`
		background-color: transparent;
		box-shadow: none;
		font-family: 15px;
		font-weight: 300;
		padding: 35px;
	`;

	return !player ? (
		<h1>{ImSpinner3}</h1>
	) : (
		<>
			<img
				src="https://i.pinimg.com/originals/7b/16/db/7b16db41202af196e519d8ac97e0236c.png"
				alt="Plate Transparent"
				css={playerImg}
			/>
			<svg
				xmlns="http://www.w3.org/2000/svg"
				position="relative"
				width="100%"
				height="400"
				opacity="1"
				z-index="1000"
				viewBox="0 0 750 502.957"
			>
				<g id="sound-wave-3" transform="translate(-0.1 0.2)" opacity="0.5">
					<path
						id="Path_347"
						data-name="Path 347"
						d="M.782,0c.341,20.814.341,41.97.341,62.784l.341,62.784V376.706L1.124,439.49c0,20.814-.341,41.97-.341,62.784C.441,481.46.441,460.3.441,439.49L.1,376.706V125.569L.441,62.784C.441,41.97.441,20.814.782,0Z"
						transform="translate(0 0.482)"
						fill="#341931"
					/>
					<path
						id="Path_348"
						data-name="Path 348"
						d="M1.482,7.5c.341,18.767.341,37.534.341,56.3l.341,56.3v225.2l-.341,56.3c0,18.767-.341,37.534-.341,56.3-.341-18.767-.341-37.534-.341-56.3L.8,345.307V120.1l.341-56.3C1.141,45.034,1.482,26.267,1.482,7.5Z"
						transform="translate(1.689 18.574)"
						fill="#341931"
					/>
					<path
						id="Path_349"
						data-name="Path 349"
						d="M2.282,13.5c.341,17.061.341,34.122.341,51.183l.341,51.183V320.6L2.624,371.78c0,17.061-.341,34.122-.341,51.183-.341-17.061-.341-34.122-.341-51.183L1.6,320.6V115.866l.341-51.183C1.941,47.281,1.941,30.561,2.282,13.5Z"
						transform="translate(3.618 33.047)"
						fill="#341931"
					/>
					<path
						id="Path_350"
						data-name="Path 350"
						d="M3.324,19.1c.341,15.355.341,30.71.341,46.406l.341,46.406c0,30.71.341,61.761.341,92.47s0,61.761-.341,92.47l-.341,46.065c0,15.355-.341,30.71-.341,46.406-.341-15.355-.341-30.71-.341-46.406l-.341-46.406c0-30.71-.341-61.761-.341-92.47s0-61.761.341-92.47l.341-46.406C2.982,49.81,2.982,34.455,3.324,19.1Z"
						transform="translate(5.307 46.555)"
						fill="#341931"
					/>
					<path
						id="Path_351"
						data-name="Path 351"
						d="M3.782,15.6c.341,16.379.341,32.757.341,49.136l.341,49.136V310.413l-.341,49.136c0,16.379-.341,32.757-.341,49.136-.341-16.379-.341-32.757-.341-49.136L3.1,310.413V113.871l.341-49.136C3.441,48.357,3.782,31.979,3.782,15.6Z"
						transform="translate(7.237 38.113)"
						fill="#341931"
					/>
					<path
						id="Path_352"
						data-name="Path 352"
						d="M4.582,12.3c.341,17.4.341,34.8.341,52.207l.341,52.207V325.539l-.341,52.207c0,17.4-.341,34.8-.341,52.207-.341-18.426-.341-35.828-.341-53.23L3.9,324.516V115.689l.341-51.524C4.241,46.763,4.241,29.7,4.582,12.3Z"
						transform="translate(9.166 30.152)"
						fill="#341931"
					/>
					<path
						id="Path_353"
						data-name="Path 353"
						d="M5.382,14.8c.341,16.72.341,33.439.341,49.818l.341,49.818V313.708l-.341,50.5c0,16.72-.341,33.439-.341,49.818-.341-16.72-.341-33.439-.341-49.818L4.7,314.391V115.119L5.041,65.3C5.041,47.9,5.041,31.52,5.382,14.8Z"
						transform="translate(11.096 36.183)"
						fill="#341931"
					/>
					<path
						id="Path_354"
						data-name="Path 354"
						d="M6.324,19.7c.341,15.355.341,30.369.341,45.723l.341,45.723c0,30.369.341,61.078.341,91.447s0,61.078-.341,91.447l-.341,45.723c0,15.355-.341,30.369-.341,45.723-.341-15.355-.341-30.368-.341-45.723L5.641,294.04c0-30.369-.341-61.078-.341-91.447s0-61.078.341-91.447l.341-45.723C5.982,50.069,6.324,35.055,6.324,19.7Z"
						transform="translate(12.543 48.003)"
						fill="#341931"
					/>
					<path
						id="Path_355"
						data-name="Path 355"
						d="M7.124,26.3c.341,13.308.341,26.615.341,40.264l.341,40.264c0,26.615.341,53.571.341,80.187s0,53.571-.341,80.187l-.341,40.264c0,13.308-.341,26.615-.341,40.264-.341-13.308-.341-26.615-.341-40.264L6.441,266.86c0-26.615-.341-53.571-.341-80.187s0-53.571.341-80.187l.341-40.264C6.782,52.915,6.782,39.608,7.124,26.3Z"
						transform="translate(14.473 63.923)"
						fill="#341931"
					/>
					<path
						id="Path_356"
						data-name="Path 356"
						d="M7.682,33.3c.341,22.862.682,45.382.682,68.244V238.032c0,22.862-.341,45.382-.682,68.244C7.341,283.414,7,260.893,7,238.032V101.544C7,79.023,7.341,56.162,7.682,33.3Z"
						transform="translate(16.644 80.808)"
						fill="#341931"
					/>
					<path
						id="Path_357"
						data-name="Path 357"
						d="M8.382,39c.341,19.45.682,38.9.682,58.348V214.728c0,19.449-.341,38.9-.682,58.69-.341-19.449-.682-38.9-.682-58.69V97.349C8.041,77.9,8.041,58.45,8.382,39Z"
						transform="translate(18.333 94.558)"
						fill="#341931"
					/>
					<path
						id="Path_358"
						data-name="Path 358"
						d="M9.182,44.8c.341,16.037.682,32.416.682,48.453v96.906c0,16.037-.341,32.416-.682,48.453-.341-15.7-.682-31.733-.682-48.112V93.594C8.5,77.216,8.841,61.179,9.182,44.8Z"
						transform="translate(20.262 108.549)"
						fill="#341931"
					/>
					<path
						id="Path_359"
						data-name="Path 359"
						d="M9.982,41.6c.341,18.085.682,36.169.682,54.254V203.679c0,18.085-.341,36.169-.682,54.254-.341-18.085-.682-36.169-.682-54.254V95.854C9.3,77.769,9.641,59.685,9.982,41.6Z"
						transform="translate(22.192 100.83)"
						fill="#341931"
					/>
					<path
						id="Path_360"
						data-name="Path 360"
						d="M10.682,37.8c.341,20.132.682,40.264.682,60.737V220.011c0,20.132-.341,40.264-.682,60.737C10.341,260.616,10,240.484,10,220.011V98.537C10.341,78.064,10.341,57.932,10.682,37.8Z"
						transform="translate(23.881 91.663)"
						fill="#341931"
					/>
					<path
						id="Path_361"
						data-name="Path 361"
						d="M11.482,33.3c.341,22.862.682,45.382.682,68.244V238.032c0,22.862-.341,45.382-.682,68.244-.341-22.862-.682-45.382-.682-68.244V101.544C10.8,79.023,11.141,56.162,11.482,33.3Z"
						transform="translate(25.81 80.808)"
						fill="#341931"
					/>
					<path
						id="Path_362"
						data-name="Path 362"
						d="M12.282,35.6c.341,21.5.682,42.994.682,64.149v128.3c0,21.5-.341,42.994-.682,64.149-.341-21.5-.682-42.994-.682-64.149V99.749C11.6,78.594,11.941,57.1,12.282,35.6Z"
						transform="translate(27.74 86.356)"
						fill="#341931"
					/>
					<path
						id="Path_363"
						data-name="Path 363"
						d="M12.982,39.9c.341,19.108.682,37.875.682,56.984V210.168c0,19.108-.341,37.875-.682,56.984-.341-19.108-.682-37.875-.682-56.984V96.884C12.641,78.117,12.641,59.008,12.982,39.9Z"
						transform="translate(29.429 96.729)"
						fill="#341931"
					/>
					<path
						id="Path_364"
						data-name="Path 364"
						d="M13.782,42.9c.341,17.4.682,34.463.682,51.865V198.5c0,17.4-.341,34.463-.682,51.865-.341-17.4-.682-34.463-.682-51.865V94.765C13.1,77.7,13.441,60.3,13.782,42.9Z"
						transform="translate(31.359 103.966)"
						fill="#341931"
					/>
					<path
						id="Path_365"
						data-name="Path 365"
						d="M14.582,47.1c.341,15.014.682,29.686.682,44.7v90.082c0,15.014-.341,29.686-.682,44.7-.341-15.014-.682-29.686-.682-44.7V91.8C13.9,76.786,14.241,62.114,14.582,47.1Z"
						transform="translate(33.288 114.097)"
						fill="#341931"
					/>
					<path
						id="Path_366"
						data-name="Path 366"
						d="M15.282,51.6c.341,12.284.682,24.568.682,37.193v73.7c0,12.284-.341,24.568-.682,37.193-.341-12.284-.682-24.568-.682-37.193v-73.7C14.941,76.168,14.941,63.884,15.282,51.6Z"
						transform="translate(34.977 124.952)"
						fill="#341931"
					/>
					<path
						id="Path_367"
						data-name="Path 367"
						d="M16.082,58c.341,8.872.682,17.4.682,26.274v51.865c0,8.872-.341,17.4-.682,26.274-.341-8.872-.682-17.4-.682-26.274V84.274C15.4,75.4,15.741,66.53,16.082,58Z"
						transform="translate(36.907 140.39)"
						fill="#341931"
					/>
					<path
						id="Path_368"
						data-name="Path 368"
						d="M16.882,63.1c.341,5.8.682,11.6.682,17.4v34.122c0,5.8-.341,11.6-.682,17.4-.341-5.8-.682-11.6-.682-17.4V80.5C16.2,74.7,16.541,68.9,16.882,63.1Z"
						transform="translate(38.836 152.692)"
						fill="#341931"
					/>
					<path
						id="Path_369"
						data-name="Path 369"
						d="M17.824,66.4c.341,4.095.682,7.848.682,11.943s.341,7.848.341,11.943,0,7.848-.341,11.943c0,4.095-.341,7.848-.682,11.943-.341-4.436-.341-8.189-.682-12.284,0-4.095-.341-7.848-.341-11.943s0-7.848.341-11.943C17.482,74.248,17.482,70.153,17.824,66.4Z"
						transform="translate(40.284 160.652)"
						fill="#341931"
					/>
					<path
						id="Path_370"
						data-name="Path 370"
						d="M18.624,68.8a55.8,55.8,0,0,1,.682,7.507c0,2.389.341,5.118.341,7.507a55.284,55.284,0,0,1-.341,7.507,55.8,55.8,0,0,1-.682,7.507,55.8,55.8,0,0,1-.682-7.507c0-2.389-.341-5.118-.341-7.507a55.284,55.284,0,0,1,.341-7.507A61.283,61.283,0,0,1,18.624,68.8Z"
						transform="translate(42.213 166.441)"
						fill="#341931"
					/>
					<path
						id="Path_371"
						data-name="Path 371"
						d="M19.424,66.4c.341,4.095.682,7.848.682,11.943s.341,7.848.341,11.943,0,7.848-.341,11.943c0,4.095-.341,7.848-.682,11.943-.341-4.095-.682-7.848-.682-11.943S18.4,94.38,18.4,90.285s0-7.848.341-11.943C18.741,74.248,19.082,70.153,19.424,66.4Z"
						transform="translate(44.143 160.652)"
						fill="#341931"
					/>
					<path
						id="Path_372"
						data-name="Path 372"
						d="M19.882,62.1c.341,6.483.682,12.625.682,19.108v38.217c0,6.483-.341,12.625-.682,19.108-.341-6.483-.682-12.625-.682-19.108V81.208C19.541,74.725,19.541,68.242,19.882,62.1Z"
						transform="translate(46.073 150.28)"
						fill="#341931"
					/>
					<path
						id="Path_373"
						data-name="Path 373"
						d="M20.682,59.2c.341,7.848.682,16.037.682,23.885v47.771c0,7.848-.341,16.037-.682,23.885C20.341,146.893,20,138.7,20,130.856V83.085C20,75.237,20.341,67.389,20.682,59.2Z"
						transform="translate(48.003 143.284)"
						fill="#341931"
					/>
					<path
						id="Path_374"
						data-name="Path 374"
						d="M21.482,62.1c.341,6.483.682,12.625.682,19.108v38.217c0,6.483-.341,12.625-.682,19.108-.341-6.483-.682-12.625-.682-19.108V81.208C20.8,74.725,21.141,68.242,21.482,62.1Z"
						transform="translate(49.932 150.28)"
						fill="#341931"
					/>
					<path
						id="Path_375"
						data-name="Path 375"
						d="M22.424,66.4c.341,4.095.682,7.848.682,11.943s.341,7.848.341,11.943,0,7.848-.341,11.943c0,4.095-.341,7.848-.682,11.943-.341-4.095-.682-7.848-.682-11.943S21.4,94.38,21.4,90.285s0-7.848.341-11.943S22.082,70.153,22.424,66.4Z"
						transform="translate(51.38 160.652)"
						fill="#341931"
					/>
					<path
						id="Path_376"
						data-name="Path 376"
						d="M23.224,68.8a55.8,55.8,0,0,1,.682,7.507c0,2.389.341,5.118.341,7.507a55.285,55.285,0,0,1-.341,7.507,55.8,55.8,0,0,1-.682,7.507,55.8,55.8,0,0,1-.682-7.507c0-2.389-.341-5.118-.341-7.507a55.285,55.285,0,0,1,.341-7.507C22.882,73.918,22.882,71.53,23.224,68.8Z"
						transform="translate(53.309 166.441)"
						fill="#341931"
					/>
					<path
						id="Path_377"
						data-name="Path 377"
						d="M24.024,71.2a14.511,14.511,0,0,1,.682,3.753c0,1.365.341,2.389.341,3.753a14,14,0,0,1-.341,3.753,14.511,14.511,0,0,1-.682,3.753,14.511,14.511,0,0,1-.682-3.753c0-1.365-.341-2.389-.341-3.753a14,14,0,0,1,.341-3.753A12.267,12.267,0,0,1,24.024,71.2Z"
						transform="translate(55.239 172.231)"
						fill="#341931"
					/>
					<path
						id="Path_378"
						data-name="Path 378"
						d="M24.724,68.8a55.8,55.8,0,0,1,.682,7.507c0,2.389.341,5.118.341,7.507a55.284,55.284,0,0,1-.341,7.507,55.8,55.8,0,0,1-.682,7.507,55.8,55.8,0,0,1-.682-7.507c0-2.389-.341-5.118-.341-7.507a55.284,55.284,0,0,1,.341-7.507C24.382,73.918,24.382,71.53,24.724,68.8Z"
						transform="translate(56.928 166.441)"
						fill="#341931"
					/>
					<path
						id="Path_379"
						data-name="Path 379"
						d="M25.765,64.7c.341,4.777.682,9.9.682,14.672V93.7c0,4.777,0,9.9-.341,14.672,0,4.777-.341,9.9-.682,14.672-.341-4.777-.682-9.9-.682-14.672S24.4,98.481,24.4,93.7V79.372C25.424,74.6,25.424,69.818,25.765,64.7Z"
						transform="translate(58.616 156.551)"
						fill="#341931"
					/>
					<path
						id="Path_380"
						data-name="Path 380"
						d="M26.082,60.5c.341,7.166.682,14.672.682,21.838v43.676c0,7.166-.341,14.672-.682,21.838-.341-7.166-.682-14.672-.682-21.838V82.338C25.4,75.172,25.741,67.666,26.082,60.5Z"
						transform="translate(61.028 146.42)"
						fill="#341931"
					/>
					<path
						id="Path_381"
						data-name="Path 381"
						d="M26.882,51.6c.341,12.284.682,24.568.682,37.193v73.7c0,12.284-.341,24.568-.682,37.193-.341-12.284-.682-24.568-.682-37.193v-73.7C26.2,76.168,26.2,63.884,26.882,51.6Z"
						transform="translate(62.958 124.952)"
						fill="#341931"
					/>
					<path
						id="Path_382"
						data-name="Path 382"
						d="M27.582,40.9c.341,18.426.682,36.852.682,55.278V206.733c0,18.426-.341,36.852-.682,55.277-.341-18.426-.682-36.852-.682-55.277V96.178C27.241,77.752,27.241,59.326,27.582,40.9Z"
						transform="translate(64.647 99.141)"
						fill="#341931"
					/>
					<path
						id="Path_383"
						data-name="Path 383"
						d="M28.624,31.6c0,11.943.341,23.885.341,35.487l.341,35.487c0,23.544.341,47.429.341,70.974s0,47.429-.341,70.974l-.341,36.169c0,11.943-.341,23.544-.341,35.487-.341-11.943-.341-23.544-.341-35.487L27.941,245.2c0-23.544-.341-47.43-.341-70.974s0-47.429.341-70.974l.341-36.169C28.282,55.485,28.282,43.543,28.624,31.6Z"
						transform="translate(66.335 76.708)"
						fill="#341931"
					/>
					<path
						id="Path_384"
						data-name="Path 384"
						d="M29.424,23.4c.341,14.331.341,28.321.341,42.652l.341,42.652c0,28.321.341,56.642.341,84.964s0,56.642-.341,84.964l-.341,42.652c0,14.331-.341,28.321-.341,42.652-.341-14.331-.341-28.321-.341-42.652l-.341-42.652c0-28.321-.341-56.642-.341-84.964s0-56.642.341-84.964l.341-42.652C29.082,51.721,29.082,37.731,29.424,23.4Z"
						transform="translate(68.265 56.928)"
						fill="#341931"
					/>
					<path
						id="Path_385"
						data-name="Path 385"
						d="M30.124,27.5c.341,12.966.341,25.933.341,38.9l.341,38.9c0,25.933.341,52.207.341,78.139s0,52.207-.341,78.139l-.341,38.9c0,12.966-.341,25.933-.341,38.9-.341-12.966-.341-25.933-.341-38.9l-.341-38.9c0-25.933-.341-52.207-.341-78.139s0-52.207.341-78.139l.341-38.558C29.782,53.774,30.124,40.466,30.124,27.5Z"
						transform="translate(69.954 66.818)"
						fill="#341931"
					/>
					<path
						id="Path_386"
						data-name="Path 386"
						d="M30.682,35.6c.341,21.5.682,42.994.682,64.149v128.3c0,21.5-.341,42.994-.682,64.149C30.341,270.7,30,249.2,30,228.048V99.749C30,78.594,30.341,57.1,30.682,35.6Z"
						transform="translate(72.125 86.356)"
						fill="#341931"
					/>
					<path
						id="Path_387"
						data-name="Path 387"
						d="M31.724,30.2c0,12.284,0,24.568.341,36.852l.341,36.852c0,24.568.341,49.136.341,73.7s0,49.136-.341,73.7l-.341,36.852c0,12.284-.341,24.568-.341,36.852-.341-12.284-.341-24.568-.341-36.852l-.341-36.852c0-24.568-.341-49.136-.341-73.7s0-49.136.341-73.7V67.052C31.382,54.768,31.382,42.484,31.724,30.2Z"
						transform="translate(73.813 73.331)"
						fill="#341931"
					/>
					<path
						id="Path_388"
						data-name="Path 388"
						d="M32.182,37.8c.341,20.132.682,40.264.682,60.737V220.011c0,20.132-.341,40.264-.682,60.737-.341-20.132-.682-40.264-.682-60.737V98.537C31.841,78.064,31.841,57.932,32.182,37.8Z"
						transform="translate(75.743 91.663)"
						fill="#341931"
					/>
					<path
						id="Path_389"
						data-name="Path 389"
						d="M32.982,44.8c.341,16.037.682,32.416.682,48.453v96.906c0,16.037-.341,32.416-.682,48.453-.341-16.037-.682-32.416-.682-48.453V93.253C32.3,77.216,32.641,61.179,32.982,44.8Z"
						transform="translate(77.673 108.549)"
						fill="#341931"
					/>
					<path
						id="Path_390"
						data-name="Path 390"
						d="M33.782,54.4c.341,10.578.682,21.5.682,32.075v64.149c0,10.578-.341,21.5-.682,32.075-.341-10.578-.682-21.5-.682-32.075V86.475C33.1,75.9,33.441,65.319,33.782,54.4Z"
						transform="translate(79.602 131.706)"
						fill="#341931"
					/>
					<path
						id="Path_391"
						data-name="Path 391"
						d="M34.482,47.1c.341,15.014.682,29.686.682,44.7v90.082c0,15.014-.341,29.686-.682,44.7-.341-15.014-.682-29.686-.682-44.7V91.8C34.141,76.786,34.141,62.114,34.482,47.1Z"
						transform="translate(81.291 114.097)"
						fill="#341931"
					/>
					<path
						id="Path_392"
						data-name="Path 392"
						d="M35.282,37.8c.341,20.132.682,40.264.682,60.737V220.011c0,20.132-.341,40.264-.682,60.737-.341-20.132-.682-40.264-.682-60.737V98.537C34.6,78.064,34.941,57.932,35.282,37.8Z"
						transform="translate(83.221 91.663)"
						fill="#341931"
					/>
					<path
						id="Path_393"
						data-name="Path 393"
						d="M36.082,47.1c.341,15.014.682,29.686.682,44.7v90.082c0,15.014-.341,29.686-.682,44.7-.341-15.014-.682-29.686-.682-44.7V91.8C35.4,76.786,35.741,62.114,36.082,47.1Z"
						transform="translate(85.15 114.097)"
						fill="#341931"
					/>
					<path
						id="Path_394"
						data-name="Path 394"
						d="M36.782,58c.341,8.872.682,17.4.682,26.274v51.865c0,8.872-.341,17.4-.682,26.274-.341-8.872-.682-17.4-.682-26.274V84.274C36.441,75.4,36.441,66.53,36.782,58Z"
						transform="translate(86.839 140.39)"
						fill="#341931"
					/>
					<path
						id="Path_395"
						data-name="Path 395"
						d="M38.065,64.7c.341,4.777.682,9.9.682,14.672V93.7c0,4.777,0,9.9-.341,14.672,0,4.777-.341,9.9-.682,14.672-.341-4.777-.682-9.9-.682-14.672S36.7,98.481,36.7,93.7V79.372C37.382,74.6,37.724,69.818,38.065,64.7Z"
						transform="translate(88.286 156.551)"
						fill="#341931"
					/>
					<path
						id="Path_396"
						data-name="Path 396"
						d="M38.624,68.8a55.8,55.8,0,0,1,.682,7.507c0,2.389.341,5.118.341,7.507a55.285,55.285,0,0,1-.341,7.507,55.8,55.8,0,0,1-.682,7.507,55.8,55.8,0,0,1-.682-7.507c0-2.389-.341-5.118-.341-7.507a55.285,55.285,0,0,1,.341-7.507A61.279,61.279,0,0,1,38.624,68.8Z"
						transform="translate(90.457 166.441)"
						fill="#341931"
					/>
					<path
						id="Path_397"
						data-name="Path 397"
						d="M39.565,65.6c.341,4.436.682,8.872.682,13.308V91.874c0,4.436,0,8.872-.341,13.308,0,4.436-.341,8.872-.682,13.308-.341-4.436-.682-8.872-.682-13.308S38.2,96.31,38.2,91.874V78.908C39.224,74.472,39.224,70.036,39.565,65.6Z"
						transform="translate(91.905 158.722)"
						fill="#341931"
					/>
					<path
						id="Path_398"
						data-name="Path 398"
						d="M39.882,59.2c.341,7.848.682,16.037.682,23.885v47.771c0,7.848-.341,16.037-.682,23.885-.341-7.848-.682-16.037-.682-23.885V83.085C39.2,75.237,39.541,67.389,39.882,59.2Z"
						transform="translate(94.317 143.284)"
						fill="#341931"
					/>
					<path
						id="Path_399"
						data-name="Path 399"
						d="M40.682,53.4c.341,11.26.682,22.52.682,34.122v68.244c0,11.26-.341,22.52-.682,34.122-.341-11.26-.682-22.52-.682-34.122V87.522C40,75.92,40.341,64.66,40.682,53.4Z"
						transform="translate(96.246 129.294)"
						fill="#341931"
					/>
					<path
						id="Path_400"
						data-name="Path 400"
						d="M41.382,56.8c.341,9.554.682,18.767.682,28.321v55.96c0,9.554-.341,18.767-.682,28.321-.341-9.554-.682-18.767-.682-28.321V85.121C41.041,75.567,41.041,66.013,41.382,56.8Z"
						transform="translate(97.935 137.495)"
						fill="#341931"
					/>
					<path
						id="Path_401"
						data-name="Path 401"
						d="M42.182,61.7c.341,6.483.682,13.308.682,19.791v39.581c0,6.483-.341,13.308-.682,19.791-.341-6.483-.682-13.308-.682-19.791V81.491C41.5,74.666,41.841,68.183,42.182,61.7Z"
						transform="translate(99.865 149.315)"
						fill="#341931"
					/>
					<path
						id="Path_402"
						data-name="Path 402"
						d="M43.465,65.6c.341,4.436.682,8.872.682,13.308V91.874c0,4.436,0,8.872-.341,13.308,0,4.436-.341,8.872-.682,13.308-.341-4.436-.682-8.872-.682-13.308S42.1,96.31,42.1,91.874V78.908C42.782,74.472,43.124,70.036,43.465,65.6Z"
						transform="translate(101.312 158.722)"
						fill="#341931"
					/>
					<path
						id="Path_403"
						data-name="Path 403"
						d="M43.924,68a84.02,84.02,0,0,1,.682,8.872c0,3.071.341,6.142.341,8.872a74.214,74.214,0,0,1-.341,8.872,72.049,72.049,0,0,1-.682,8.872,84.016,84.016,0,0,1-.682-8.872c0-3.071-.341-6.142-.341-8.872a74.215,74.215,0,0,1,.341-8.872C43.582,74.142,43.582,71.071,43.924,68Z"
						transform="translate(103.242 164.512)"
						fill="#341931"
					/>
					<path
						id="Path_404"
						data-name="Path 404"
						d="M44.724,69.9a33.62,33.62,0,0,1,.682,5.8c0,2.047.341,3.753.341,5.8a33.1,33.1,0,0,1-.341,5.8,33.618,33.618,0,0,1-.682,5.8,33.618,33.618,0,0,1-.682-5.8c0-2.047-.341-3.753-.341-5.8a33.1,33.1,0,0,1,.341-5.8A38,38,0,0,1,44.724,69.9Z"
						transform="translate(105.172 169.095)"
						fill="#341931"
					/>
					<path
						id="Path_405"
						data-name="Path 405"
						d="M69.082,179.886c-.341-10.237-.682-20.814-.682-31.051V86.051c0-10.237.341-20.814.682-31.051.341,10.237.682,20.814.682,31.051v62.784C69.424,159.072,69.424,169.308,69.082,179.886Z"
						transform="translate(164.753 133.153)"
						fill="#341931"
					/>
					<path
						id="Path_406"
						data-name="Path 406"
						d="M69.782,257.933c-.341-18.085-.682-36.169-.682-54.254V95.854c0-18.085.341-36.169.682-54.254.341,18.085.682,36.169.682,54.254V203.679C70.465,221.764,70.124,239.848,69.782,257.933Z"
						transform="translate(166.441 100.83)"
						fill="#341931"
					/>
					<path
						id="Path_407"
						data-name="Path 407"
						d="M70.824,352.188c-.341-13.649-.341-27.3-.341-40.946L70.141,270.3c0-27.3-.341-54.254-.341-81.551s0-54.254.341-81.551l.341-40.946c0-13.649.341-27.3.341-40.946.341,13.649.341,27.3.341,40.946l.341,40.946c0,27.3.341,54.254.341,81.551s0,54.254-.341,81.551l-.341,40.946C71.165,325.232,71.165,338.539,70.824,352.188Z"
						transform="translate(168.13 61.511)"
						fill="#341931"
					/>
					<path
						id="Path_408"
						data-name="Path 408"
						d="M71.382,413.544c-.341-16.72-.341-33.439-.341-49.818L70.7,313.908V114.636l.341-49.818c0-16.72.341-33.439.341-49.818.341,16.72.341,33.439.341,49.818l.341,49.818V313.908l-.341,49.818C71.382,380.446,71.382,397.166,71.382,413.544Z"
						transform="translate(170.301 36.665)"
						fill="#341931"
					/>
					<path
						id="Path_409"
						data-name="Path 409"
						d="M72.324,385.487c-.341-15.355-.341-30.368-.341-45.723l-.341-45.723c0-30.368-.341-61.078-.341-91.447s0-61.078.341-91.447l.341-45.723c0-15.355.341-30.369.341-45.723.341,15.355.341,30.369.341,45.723l.341,45.723c0,30.369.341,61.078.341,91.447s0,61.078-.341,91.447l-.341,45.723C72.665,355.119,72.665,370.473,72.324,385.487Z"
						transform="translate(171.748 48.003)"
						fill="#341931"
					/>
					<path
						id="Path_410"
						data-name="Path 410"
						d="M73.124,347.287c-.341-13.308-.341-26.615-.341-40.264l-.341-40.264c0-26.615-.341-53.571-.341-80.187s0-53.571.341-80.187l.341-39.923c0-13.308.341-26.615.341-40.264.341,13.308.341,26.615.341,40.264l.341,40.264c0,26.615.341,53.571.341,80.187s0,53.571-.341,80.187l-.341,40.264C73.465,320.672,73.465,333.98,73.124,347.287Z"
						transform="translate(173.678 63.682)"
						fill="#341931"
					/>
					<path
						id="Path_411"
						data-name="Path 411"
						d="M73.682,306.275C73.341,283.414,73,260.893,73,238.032V101.544c0-22.862.341-45.382.682-68.244.341,22.862.682,45.382.682,68.244V238.032C74.024,260.893,74.024,283.414,73.682,306.275Z"
						transform="translate(175.849 80.808)"
						fill="#341931"
					/>
					<path
						id="Path_412"
						data-name="Path 412"
						d="M74.382,273.659c-.341-19.449-.682-38.9-.682-58.69V97.59c0-19.45.341-38.9.682-58.69.341,19.45.682,38.9.682,58.69V214.969C75.065,234.419,74.724,253.868,74.382,273.659Z"
						transform="translate(177.537 94.317)"
						fill="#341931"
					/>
					<path
						id="Path_413"
						data-name="Path 413"
						d="M75.182,238.813c-.341-16.037-.682-32.416-.682-48.453V93.453c0-16.037.341-32.416.682-48.453.341,16.037.682,32.416.682,48.453v96.906C75.865,206.4,75.524,222.434,75.182,238.813Z"
						transform="translate(179.467 109.031)"
						fill="#341931"
					/>
					<path
						id="Path_414"
						data-name="Path 414"
						d="M75.982,257.933c-.341-18.085-.682-36.169-.682-54.254V95.854c0-18.085.341-36.169.682-54.254.341,18.085.682,36.169.682,54.254V203.679C76.324,221.764,76.324,239.848,75.982,257.933Z"
						transform="translate(181.397 100.83)"
						fill="#341931"
					/>
					<path
						id="Path_415"
						data-name="Path 415"
						d="M76.682,280.548C76.341,260.416,76,240.284,76,219.811V98.337c0-20.132.341-40.264.682-60.737.341,20.132.682,40.264.682,60.737V219.811C77.365,240.284,77.024,260.416,76.682,280.548Z"
						transform="translate(183.085 91.181)"
						fill="#341931"
					/>
					<path
						id="Path_416"
						data-name="Path 416"
						d="M77.482,306.275c-.341-22.862-.682-45.382-.682-68.244V101.544c0-22.862.341-45.382.682-68.244.341,22.862.682,45.382.682,68.244V238.032C78.165,260.893,77.824,283.414,77.482,306.275Z"
						transform="translate(185.015 80.808)"
						fill="#341931"
					/>
					<path
						id="Path_417"
						data-name="Path 417"
						d="M78.282,292.4c-.341-21.5-.682-42.994-.682-64.149V99.949c0-21.5.341-42.994.682-64.149.341,21.5.682,42.994.682,64.149v128.3C78.624,249.4,78.624,270.9,78.282,292.4Z"
						transform="translate(186.945 86.839)"
						fill="#341931"
					/>
					<path
						id="Path_418"
						data-name="Path 418"
						d="M78.982,267.352c-.341-19.108-.682-37.875-.682-56.984V97.084c0-19.108.341-37.875.682-56.984.341,19.108.682,37.875.682,56.984V210.368C79.665,229.477,79.324,248.244,78.982,267.352Z"
						transform="translate(188.633 97.211)"
						fill="#341931"
					/>
					<path
						id="Path_419"
						data-name="Path 419"
						d="M79.782,250.361c-.341-17.4-.682-34.463-.682-51.865V94.765c0-17.4.341-34.463.682-51.865.341,17.4.682,34.463.682,51.865V198.5C80.465,215.9,80.124,232.959,79.782,250.361Z"
						transform="translate(190.563 103.966)"
						fill="#341931"
					/>
					<path
						id="Path_420"
						data-name="Path 420"
						d="M80.582,226.381c-.341-15.014-.682-29.686-.682-44.7V91.6c0-15.014.341-29.686.682-44.7.341,15.014.682,29.686.682,44.7v90.082C80.924,196.7,80.924,211.368,80.582,226.381Z"
						transform="translate(192.493 113.614)"
						fill="#341931"
					/>
					<path
						id="Path_421"
						data-name="Path 421"
						d="M81.282,199.789c-.341-12.284-.682-24.568-.682-37.193v-73.7c0-12.284.341-24.568.682-37.193.341,12.284.682,24.568.682,37.193v73.7C81.965,174.88,81.624,187.164,81.282,199.789Z"
						transform="translate(194.182 125.193)"
						fill="#341931"
					/>
					<path
						id="Path_422"
						data-name="Path 422"
						d="M82.082,162.413c-.341-8.872-.682-17.4-.682-26.274V84.274c0-8.872.341-17.4.682-26.274.341,8.872.682,17.4.682,26.274v51.865C82.765,145.011,82.424,153.883,82.082,162.413Z"
						transform="translate(196.111 140.39)"
						fill="#341931"
					/>
					<path
						id="Path_423"
						data-name="Path 423"
						d="M82.882,132.226c-.341-5.8-.682-11.6-.682-17.4V80.7c0-5.8.341-11.6.682-17.4.341,5.8.682,11.6.682,17.4v34.122C83.224,120.625,83.224,126.426,82.882,132.226Z"
						transform="translate(198.041 153.174)"
						fill="#341931"
					/>
					<path
						id="Path_424"
						data-name="Path 424"
						d="M83.824,114.071c-.341-4.095-.341-7.848-.682-11.943,0-4.095-.341-7.848-.341-11.943s0-7.848.341-11.943c0-4.095.341-7.848.682-11.943.341,4.095.682,7.848.682,11.943s.341,7.848.341,11.943,0,7.848-.341,11.943C84.506,106.223,84.165,109.976,83.824,114.071Z"
						transform="translate(199.488 160.411)"
						fill="#341931"
					/>
					<path
						id="Path_425"
						data-name="Path 425"
						d="M84.624,99.027a55.8,55.8,0,0,1-.682-7.507c0-2.389-.341-5.118-.341-7.507a55.285,55.285,0,0,1,.341-7.507A55.8,55.8,0,0,1,84.624,69a55.8,55.8,0,0,1,.682,7.507c0,2.389.341,5.118.341,7.507a55.29,55.29,0,0,1-.341,7.507A61.282,61.282,0,0,1,84.624,99.027Z"
						transform="translate(201.418 166.924)"
						fill="#341931"
					/>
					<path
						id="Path_426"
						data-name="Path 426"
						d="M85.424,114.071c-.341-4.095-.682-7.848-.682-11.943S84.4,94.28,84.4,90.185s0-7.848.341-11.943c0-4.095.341-7.848.682-11.943.341,4.095.682,7.848.682,11.943s.341,7.848.341,11.943,0,7.848-.341,11.943S85.765,109.976,85.424,114.071Z"
						transform="translate(203.348 160.411)"
						fill="#341931"
					/>
					<path
						id="Path_427"
						data-name="Path 427"
						d="M85.882,138.633c-.341-6.483-.682-12.625-.682-19.108V81.308c0-6.483.341-12.625.682-19.108.341,6.483.682,12.625.682,19.108v38.217C86.565,125.667,86.224,132.15,85.882,138.633Z"
						transform="translate(205.278 150.521)"
						fill="#341931"
					/>
					<path
						id="Path_428"
						data-name="Path 428"
						d="M86.682,154.941C86.341,147.093,86,138.9,86,131.056V83.285c0-7.848.341-16.037.682-23.885.341,7.848.682,16.037.682,23.885v47.771C87.365,138.9,87.024,147.093,86.682,154.941Z"
						transform="translate(207.207 143.767)"
						fill="#341931"
					/>
					<path
						id="Path_429"
						data-name="Path 429"
						d="M87.482,138.633c-.341-6.483-.682-12.625-.682-19.108V81.308c0-6.483.341-12.625.682-19.108.341,6.483.682,12.625.682,19.108v38.217C87.824,125.667,87.824,132.15,87.482,138.633Z"
						transform="translate(209.137 150.521)"
						fill="#341931"
					/>
					<path
						id="Path_430"
						data-name="Path 430"
						d="M88.424,114.071c-.341-4.095-.682-7.848-.682-11.943S87.4,94.28,87.4,90.185s0-7.848.341-11.943c0-4.095.341-7.848.682-11.943.341,4.095.682,7.848.682,11.943s.341,7.848.341,11.943,0,7.848-.341,11.943A70.129,70.129,0,0,1,88.424,114.071Z"
						transform="translate(210.584 160.411)"
						fill="#341931"
					/>
					<path
						id="Path_431"
						data-name="Path 431"
						d="M89.224,99.027a55.8,55.8,0,0,1-.682-7.507c0-2.389-.341-5.118-.341-7.507a55.285,55.285,0,0,1,.341-7.507A55.8,55.8,0,0,1,89.224,69a55.8,55.8,0,0,1,.682,7.507c0,2.389.341,5.118.341,7.507a55.285,55.285,0,0,1-.341,7.507A61.282,61.282,0,0,1,89.224,99.027Z"
						transform="translate(212.514 166.924)"
						fill="#341931"
					/>
					<path
						id="Path_432"
						data-name="Path 432"
						d="M90.024,86.114a14.511,14.511,0,0,1-.682-3.753C89.341,81,89,79.972,89,78.607a14,14,0,0,1,.341-3.753,14.511,14.511,0,0,1,.682-3.753,14.511,14.511,0,0,1,.682,3.753c0,1.365.341,2.389.341,3.753a14,14,0,0,1-.341,3.753C90.365,83.384,90.365,84.749,90.024,86.114Z"
						transform="translate(214.444 171.989)"
						fill="#341931"
					/>
					<path
						id="Path_433"
						data-name="Path 433"
						d="M90.724,99.027a55.8,55.8,0,0,1-.682-7.507c0-2.389-.341-5.118-.341-7.507a55.285,55.285,0,0,1,.341-7.507A55.8,55.8,0,0,1,90.724,69a55.8,55.8,0,0,1,.682,7.507c0,2.389.341,5.118.341,7.507a55.285,55.285,0,0,1-.341,7.507A29.269,29.269,0,0,1,90.724,99.027Z"
						transform="translate(216.132 166.924)"
						fill="#341931"
					/>
					<path
						id="Path_434"
						data-name="Path 434"
						d="M91.282,123.148c-.341-4.777-.682-9.9-.682-14.672V94.145c0-4.777,0-9.9.341-14.672,0-4.777.341-9.9.682-14.672.341,4.777.682,9.9.682,14.672s.341,9.9.341,14.672v14.331C91.965,113.253,91.624,118.371,91.282,123.148Z"
						transform="translate(218.303 156.793)"
						fill="#341931"
					/>
					<path
						id="Path_435"
						data-name="Path 435"
						d="M92.082,147.952c-.341-7.166-.682-14.672-.682-21.838V82.438c0-7.166.341-14.672.682-21.838.341,7.166.682,14.672.682,21.838v43.676C92.424,133.28,92.424,140.445,92.082,147.952Z"
						transform="translate(220.233 146.661)"
						fill="#341931"
					/>
					<path
						id="Path_436"
						data-name="Path 436"
						d="M92.782,199.789c-.341-12.284-.682-24.568-.682-37.193v-73.7c0-12.284.341-24.568.682-37.193.341,12.284.682,24.568.682,37.193v73.7C93.465,174.88,93.465,187.164,92.782,199.789Z"
						transform="translate(221.922 125.193)"
						fill="#341931"
					/>
					<path
						id="Path_437"
						data-name="Path 437"
						d="M93.582,262.01c-.341-18.426-.682-36.852-.682-55.277V96.178c0-18.426.341-36.852.682-55.278.341,18.426.682,36.852.682,55.278V206.733C94.265,225.158,93.924,243.584,93.582,262.01Z"
						transform="translate(223.852 99.141)"
						fill="#341931"
					/>
					<path
						id="Path_438"
						data-name="Path 438"
						d="M94.624,316.177c-.341-11.943-.341-23.544-.341-35.487L93.941,245.2c0-23.544-.341-47.43-.341-70.974s0-47.429.341-70.974l.341-36.169c0-11.943.341-23.544.341-35.487,0,11.943.341,23.885.341,35.487l.341,35.487c0,23.544.341,47.429.341,70.974s0,47.429-.341,70.974l-.341,36.169C94.965,292.633,94.624,304.234,94.624,316.177Z"
						transform="translate(225.54 76.708)"
						fill="#341931"
					/>
					<path
						id="Path_439"
						data-name="Path 439"
						d="M95.424,363.937c-.341-14.331-.341-28.321-.341-42.652l-.341-42.652c0-28.321-.341-56.642-.341-84.964s0-56.642.341-84.964l.341-42.652c0-14.331.341-28.321.341-42.652.341,14.331.341,28.321.341,42.652l.341,42.652c0,28.321.341,56.642.341,84.964s0,56.642-.341,84.964l-.341,42.652C95.424,335.616,95.424,349.606,95.424,363.937Z"
						transform="translate(227.47 56.928)"
						fill="#341931"
					/>
					<path
						id="Path_440"
						data-name="Path 440"
						d="M96.124,339.816c-.341-12.966-.341-25.933-.341-38.9l-.341-38.9c0-25.933-.341-52.207-.341-78.139s0-52.207.341-78.139l.341-39.24c0-12.966.341-25.933.341-38.9.341,12.966.341,25.933.341,38.9l.341,38.9c0,25.933.341,52.207.341,78.139s0,52.207-.341,78.139l-.341,38.9C96.465,313.883,96.465,326.849,96.124,339.816Z"
						transform="translate(229.158 67.059)"
						fill="#341931"
					/>
					<path
						id="Path_441"
						data-name="Path 441"
						d="M96.682,292.4C96.341,270.9,96,249.4,96,228.248V99.949c0-21.5.341-42.994.682-64.149.341,21.5.682,42.994.682,64.149v128.3C97.365,249.4,97.024,270.9,96.682,292.4Z"
						transform="translate(231.329 86.839)"
						fill="#341931"
					/>
					<path
						id="Path_442"
						data-name="Path 442"
						d="M97.724,324.331c-.341-12.284-.341-24.568-.341-36.852l-.341-36.852c0-24.568-.341-49.136-.341-73.7s0-49.136.341-73.7V67.052c0-12.284.341-24.568.341-36.852.341,12.284.341,24.568.682,36.852l.341,36.852c0,24.568.341,49.136.341,73.7s0,49.136-.341,73.7l-.341,36.852C97.724,299.763,97.724,312.047,97.724,324.331Z"
						transform="translate(233.018 73.331)"
						fill="#341931"
					/>
					<path
						id="Path_443"
						data-name="Path 443"
						d="M98.182,280.548c-.341-20.132-.682-40.264-.682-60.737V98.337c0-20.132.341-40.264.682-60.737.341,20.132.682,40.264.682,60.737V219.811C98.865,240.284,98.524,260.416,98.182,280.548Z"
						transform="translate(234.948 91.181)"
						fill="#341931"
					/>
					<path
						id="Path_444"
						data-name="Path 444"
						d="M98.982,238.813c-.341-16.037-.682-32.416-.682-48.453V93.453c0-16.037.341-32.416.682-48.453.341,16.037.682,32.416.682,48.453v96.906C99.665,206.4,99.324,222.434,98.982,238.813Z"
						transform="translate(236.877 109.031)"
						fill="#341931"
					/>
					<path
						id="Path_445"
						data-name="Path 445"
						d="M99.782,182.9c-.341-10.578-.682-21.5-.682-32.075V86.675c0-10.578.341-21.5.682-32.075.341,10.578.682,21.5.682,32.075v64.149C100.124,161.4,100.124,172.321,99.782,182.9Z"
						transform="translate(238.807 132.188)"
						fill="#341931"
					/>
					<path
						id="Path_446"
						data-name="Path 446"
						d="M100.482,226.381c-.341-15.014-.682-29.686-.682-44.7V91.6c0-15.014.341-29.686.682-44.7.341,15.014.682,29.686.682,44.7v90.082C101.165,196.7,100.824,211.368,100.482,226.381Z"
						transform="translate(240.496 113.614)"
						fill="#341931"
					/>
					<path
						id="Path_447"
						data-name="Path 447"
						d="M101.282,280.548c-.341-20.132-.682-40.264-.682-60.737V98.337c0-20.132.341-40.264.682-60.737.341,20.132.682,40.264.682,60.737V219.811C101.965,240.284,101.624,260.416,101.282,280.548Z"
						transform="translate(242.425 91.181)"
						fill="#341931"
					/>
					<path
						id="Path_448"
						data-name="Path 448"
						d="M102.082,226.381c-.341-15.014-.682-29.686-.682-44.7V91.6c0-15.014.341-29.686.682-44.7.341,15.014.682,29.686.682,44.7v90.082C102.424,196.7,102.424,211.368,102.082,226.381Z"
						transform="translate(244.355 113.614)"
						fill="#341931"
					/>
					<path
						id="Path_449"
						data-name="Path 449"
						d="M102.782,162.413c-.341-8.872-.682-17.4-.682-26.274V84.274c0-8.872.341-17.4.682-26.274.341,8.872.682,17.4.682,26.274v51.865C103.465,145.011,103.124,153.883,102.782,162.413Z"
						transform="translate(246.044 140.39)"
						fill="#341931"
					/>
					<path
						id="Path_450"
						data-name="Path 450"
						d="M103.582,123.148c-.341-4.777-.682-9.9-.682-14.672V94.145c0-4.777,0-9.9.341-14.672,0-4.777.341-9.9.682-14.672.341,4.777.682,9.9.682,14.672s.341,9.9.341,14.672v14.331C104.265,113.253,103.924,118.371,103.582,123.148Z"
						transform="translate(247.973 156.793)"
						fill="#341931"
					/>
					<path
						id="Path_451"
						data-name="Path 451"
						d="M104.624,99.027a55.8,55.8,0,0,1-.682-7.507c0-2.389-.341-5.118-.341-7.507a55.285,55.285,0,0,1,.341-7.507A55.8,55.8,0,0,1,104.624,69a55.8,55.8,0,0,1,.682,7.507c0,2.389.341,5.118.341,7.507a55.285,55.285,0,0,1-.341,7.507C104.965,93.909,104.965,96.3,104.624,99.027Z"
						transform="translate(249.662 166.924)"
						fill="#341931"
					/>
					<path
						id="Path_452"
						data-name="Path 452"
						d="M105.082,118.389c-.341-4.436-.682-8.872-.682-13.308V92.115c0-4.436,0-8.872.341-13.308,0-4.436.341-8.872.682-13.308.341,4.436.682,8.872.682,13.308s.341,8.872.341,13.308v12.966C105.765,109.859,105.424,114.294,105.082,118.389Z"
						transform="translate(251.592 158.481)"
						fill="#341931"
					/>
					<path
						id="Path_453"
						data-name="Path 453"
						d="M105.882,154.941c-.341-7.848-.682-16.037-.682-23.885V83.285c0-7.848.341-16.037.682-23.885.341,7.848.682,16.037.682,23.885v47.771C106.565,138.9,106.224,147.093,105.882,154.941Z"
						transform="translate(253.521 143.767)"
						fill="#341931"
					/>
					<path
						id="Path_454"
						data-name="Path 454"
						d="M106.682,189.688c-.341-11.26-.682-22.52-.682-34.122V87.322c0-11.26.341-22.52.682-34.122.341,11.26.682,22.52.682,34.122v68.244C107.024,167.167,107.024,178.427,106.682,189.688Z"
						transform="translate(255.451 128.811)"
						fill="#341931"
					/>
					<path
						id="Path_455"
						data-name="Path 455"
						d="M107.382,169.4c-.341-9.554-.682-18.767-.682-28.321V85.121c0-9.554.341-18.767.682-28.321.341,9.554.682,18.767.682,28.321v55.96C108.065,150.635,107.724,160.189,107.382,169.4Z"
						transform="translate(257.14 137.495)"
						fill="#341931"
					/>
					<path
						id="Path_456"
						data-name="Path 456"
						d="M108.182,140.963c-.341-6.483-.682-13.308-.682-19.791V81.591c0-6.483.341-13.308.682-19.791.341,6.483.682,13.308.682,19.791v39.581C108.865,127.655,108.524,134.139,108.182,140.963Z"
						transform="translate(259.07 149.556)"
						fill="#341931"
					/>
					<path
						id="Path_457"
						data-name="Path 457"
						d="M108.982,118.389c-.341-4.436-.682-8.872-.682-13.308V92.115c0-4.436,0-8.872.341-13.308,0-4.436.341-8.872.682-13.308.341,4.436.682,8.872.682,13.308s.341,8.872.341,13.308v12.966C109.324,109.859,109.324,114.294,108.982,118.389Z"
						transform="translate(260.999 158.481)"
						fill="#341931"
					/>
					<path
						id="Path_458"
						data-name="Path 458"
						d="M109.924,103.687a84.016,84.016,0,0,1-.682-8.872c0-3.071-.341-6.142-.341-8.872a74.214,74.214,0,0,1,.341-8.872,72.049,72.049,0,0,1,.682-8.872,84.016,84.016,0,0,1,.682,8.872c0,3.071.341,6.142.341,8.872a74.215,74.215,0,0,1-.341,8.872A84,84,0,0,1,109.924,103.687Z"
						transform="translate(262.447 164.994)"
						fill="#341931"
					/>
					<path
						id="Path_459"
						data-name="Path 459"
						d="M110.724,93.1a33.618,33.618,0,0,1-.682-5.8c0-2.047-.341-3.753-.341-5.8a33.1,33.1,0,0,1,.341-5.8,33.618,33.618,0,0,1,.682-5.8,33.618,33.618,0,0,1,.682,5.8c0,2.047.341,3.753.341,5.8a33.108,33.108,0,0,1-.341,5.8A33.618,33.618,0,0,1,110.724,93.1Z"
						transform="translate(264.376 169.095)"
						fill="#341931"
					/>
					<path
						id="Path_460"
						data-name="Path 460"
						d="M45.282,63.8c.341,5.46.682,10.919.682,16.037v32.757c0,5.46-.341,10.919-.682,16.037-.341-5.46-.682-10.919-.682-16.037V79.837C44.6,74.719,44.941,69.26,45.282,63.8Z"
						transform="translate(107.343 154.38)"
						fill="#341931"
					/>
					<path
						id="Path_461"
						data-name="Path 461"
						d="M45.982,58c.341,8.872.682,17.4.682,26.274v51.865c0,8.872-.341,17.4-.682,26.274-.341-8.872-.682-17.4-.682-26.274V84.274C45.641,75.4,45.641,66.53,45.982,58Z"
						transform="translate(109.031 140.39)"
						fill="#341931"
					/>
					<path
						id="Path_462"
						data-name="Path 462"
						d="M46.782,54.1c.341,10.919.682,21.838.682,32.757v65.514c0,10.919-.341,21.838-.682,32.757-.341-10.919-.682-21.838-.682-32.757V86.857C46.1,75.938,46.441,65.019,46.782,54.1Z"
						transform="translate(110.961 130.982)"
						fill="#341931"
					/>
					<path
						id="Path_463"
						data-name="Path 463"
						d="M47.582,49.4c.341,13.649.682,27.3.682,40.605V171.9c0,13.649-.341,27.3-.682,40.605-.341-13.649-.682-27.3-.682-40.605V90.005C46.9,76.7,47.241,63.049,47.582,49.4Z"
						transform="translate(112.891 119.645)"
						fill="#341931"
					/>
					<path
						id="Path_464"
						data-name="Path 464"
						d="M48.282,55.1c.341,10.237.682,20.814.682,31.051v62.784c0,10.237-.341,20.814-.682,31.051-.341-10.237-.682-20.814-.682-31.051V86.151C47.941,75.573,47.941,65.337,48.282,55.1Z"
						transform="translate(114.579 133.394)"
						fill="#341931"
					/>
					<path
						id="Path_465"
						data-name="Path 465"
						d="M49.082,60.8c.341,7.166.682,14.331.682,21.5v42.311c0,7.166-.341,14.331-.682,21.5-.341-7.166-.682-14.331-.682-21.5V82.3C48.4,75.131,48.741,67.966,49.082,60.8Z"
						transform="translate(116.509 147.144)"
						fill="#341931"
					/>
					<path
						id="Path_466"
						data-name="Path 466"
						d="M50.365,65.3c.341,4.436.682,9.213.682,13.649V92.6c0,4.436,0,9.213-.341,13.649,0,4.436-.341,9.213-.682,13.649-.341-4.436-.682-9.213-.682-13.649S49,97.033,49,92.6V78.949C49.682,74.513,50.024,69.736,50.365,65.3Z"
						transform="translate(117.956 157.999)"
						fill="#341931"
					/>
					<path
						id="Path_467"
						data-name="Path 467"
						d="M50.824,66.4c.341,4.095.682,7.848.682,11.943s.341,7.848.341,11.943,0,7.848-.341,11.943c0,4.095-.341,7.848-.682,11.943-.341-4.436-.341-8.189-.682-12.284,0-4.095-.341-7.848-.341-11.943s0-7.848.341-11.943C50.482,74.248,50.482,70.153,50.824,66.4Z"
						transform="translate(119.886 160.652)"
						fill="#341931"
					/>
					<path
						id="Path_468"
						data-name="Path 468"
						d="M51.382,62.1c.341,6.483.682,12.625.682,19.108v38.217c0,6.483-.341,12.625-.682,19.108-.341-6.483-.682-12.625-.682-19.108V81.208C50.7,74.725,51.041,68.242,51.382,62.1Z"
						transform="translate(122.057 150.28)"
						fill="#341931"
					/>
					<path
						id="Path_469"
						data-name="Path 469"
						d="M52.182,59.2c.341,7.848.682,16.037.682,23.885v47.771c0,7.848-.341,16.037-.682,23.885-.341-7.848-.682-16.037-.682-23.885V83.085C51.5,75.237,51.841,67.389,52.182,59.2Z"
						transform="translate(123.987 143.284)"
						fill="#341931"
					/>
					<path
						id="Path_470"
						data-name="Path 470"
						d="M52.882,62.1c.341,6.483.682,12.625.682,19.108v38.217c0,6.483-.341,12.625-.682,19.108-.341-6.483-.682-12.625-.682-19.108V81.208C52.541,74.725,52.541,68.242,52.882,62.1Z"
						transform="translate(125.675 150.28)"
						fill="#341931"
					/>
					<path
						id="Path_471"
						data-name="Path 471"
						d="M53.924,66.4c.341,4.095.682,7.848.682,11.943s.341,7.848.341,11.943,0,7.848-.341,11.943c0,4.095-.341,7.848-.682,11.943-.341-4.436-.682-8.189-.682-12.284S52.9,94.039,52.9,89.944s0-7.848.341-11.943C53.241,74.248,53.582,70.153,53.924,66.4Z"
						transform="translate(127.364 160.652)"
						fill="#341931"
					/>
					<path
						id="Path_472"
						data-name="Path 472"
						d="M54.482,63.6c.341,5.46.682,10.919.682,16.72v32.757c0,5.46-.341,10.919-.682,16.72-.341-5.46-.682-10.919-.682-16.72V80.32C53.8,74.519,54.141,69.059,54.482,63.6Z"
						transform="translate(129.535 153.898)"
						fill="#341931"
					/>
					<path
						id="Path_473"
						data-name="Path 473"
						d="M55.182,58c.341,8.872.682,17.4.682,26.274v51.865c0,8.872-.341,17.4-.682,26.274-.341-8.872-.682-17.4-.682-26.274V84.274C54.841,75.4,54.841,66.53,55.182,58Z"
						transform="translate(131.223 140.39)"
						fill="#341931"
					/>
					<path
						id="Path_474"
						data-name="Path 474"
						d="M55.982,52.4c.341,11.943.682,23.885.682,35.487V158.86c0,11.943-.341,23.885-.682,35.487-.341-11.943-.682-23.885-.682-35.487V87.887C55.3,76.285,55.641,64.343,55.982,52.4Z"
						transform="translate(133.153 126.881)"
						fill="#341931"
					/>
					<path
						id="Path_475"
						data-name="Path 475"
						d="M56.782,44.8c.341,16.037.682,32.416.682,48.453v96.906c0,16.037-.341,32.416-.682,48.453-.341-16.037-.682-32.416-.682-48.453V93.253C56.1,77.216,56.441,61.179,56.782,44.8Z"
						transform="translate(135.083 108.549)"
						fill="#341931"
					/>
					<path
						id="Path_476"
						data-name="Path 476"
						d="M57.482,41.6c.341,18.085.682,36.169.682,54.254V203.679c0,18.085-.341,36.169-.682,54.254-.341-18.085-.682-36.169-.682-54.254V95.854C57.141,77.769,57.141,59.685,57.482,41.6Z"
						transform="translate(136.771 100.83)"
						fill="#341931"
					/>
					<path
						id="Path_477"
						data-name="Path 477"
						d="M58.282,37.8c.341,20.132.682,40.264.682,60.737V220.011c0,20.132-.341,40.264-.682,60.737-.341-20.132-.682-40.264-.682-60.737V98.537C57.6,78.064,57.941,57.932,58.282,37.8Z"
						transform="translate(138.701 91.663)"
						fill="#341931"
					/>
					<path
						id="Path_478"
						data-name="Path 478"
						d="M59.082,33.3c.341,22.862.682,45.382.682,68.244V238.032c0,22.862-.341,45.382-.682,68.244-.341-22.862-.682-45.382-.682-68.244V101.544C58.4,79.023,58.741,56.162,59.082,33.3Z"
						transform="translate(140.631 80.808)"
						fill="#341931"
					/>
					<path
						id="Path_479"
						data-name="Path 479"
						d="M59.782,35.6c.341,21.5.682,42.994.682,64.149v128.3c0,21.5-.341,42.994-.682,64.149-.341-21.5-.682-42.994-.682-64.149V99.749C59.441,78.594,59.441,57.1,59.782,35.6Z"
						transform="translate(142.319 86.356)"
						fill="#341931"
					/>
					<path
						id="Path_480"
						data-name="Path 480"
						d="M60.582,39.9c.341,19.108.682,37.875.682,56.984V210.168c0,19.108-.341,37.875-.682,56.984-.341-19.108-.682-37.875-.682-56.984V96.884C60.241,78.117,60.241,59.008,60.582,39.9Z"
						transform="translate(144.249 96.729)"
						fill="#341931"
					/>
					<path
						id="Path_481"
						data-name="Path 481"
						d="M61.382,42.9c.341,17.4.682,34.463.682,51.865V198.5c0,17.4-.341,34.463-.682,51.865-.341-17.4-.682-34.463-.682-51.865V94.765C60.7,77.7,61.041,60.3,61.382,42.9Z"
						transform="translate(146.179 103.966)"
						fill="#341931"
					/>
					<path
						id="Path_482"
						data-name="Path 482"
						d="M62.182,47.1c.341,15.014.682,29.686.682,44.7v90.082c0,15.014-.341,29.686-.682,44.7-.341-15.014-.682-29.686-.682-44.7V91.8C61.5,76.786,61.841,62.114,62.182,47.1Z"
						transform="translate(148.109 114.097)"
						fill="#341931"
					/>
					<path
						id="Path_483"
						data-name="Path 483"
						d="M62.882,51.6c.341,12.284.682,24.568.682,37.193v73.7c0,12.284-.341,24.568-.682,37.193-.341-12.284-.682-24.568-.682-37.193v-73.7C62.541,76.168,62.541,63.884,62.882,51.6Z"
						transform="translate(149.797 124.952)"
						fill="#341931"
					/>
					<path
						id="Path_484"
						data-name="Path 484"
						d="M63.682,58c.341,8.872.682,17.4.682,26.274v51.865c0,8.872-.341,17.4-.682,26.274-.341-8.531-.682-17.4-.682-25.933V84.615C63,75.4,63.341,66.53,63.682,58Z"
						transform="translate(151.727 140.39)"
						fill="#341931"
					/>
					<path
						id="Path_485"
						data-name="Path 485"
						d="M64.482,63.1c.341,5.8.682,11.6.682,17.4v34.122c0,5.8-.341,11.6-.682,17.4-.341-5.8-.682-11.6-.682-17.4V80.5A148.392,148.392,0,0,1,64.482,63.1Z"
						transform="translate(153.657 152.692)"
						fill="#341931"
					/>
					<path
						id="Path_486"
						data-name="Path 486"
						d="M65.424,66.4c.341,4.095.682,7.848.682,11.943s.341,7.848.341,11.943,0,7.848-.341,11.943c0,4.095-.341,7.848-.682,11.943-.341-4.095-.682-7.848-.682-11.943S64.4,94.38,64.4,90.285s0-7.848.341-11.943S65.082,70.153,65.424,66.4Z"
						transform="translate(155.104 160.652)"
						fill="#341931"
					/>
					<path
						id="Path_487"
						data-name="Path 487"
						d="M66.224,68.8a55.8,55.8,0,0,1,.682,7.507c0,2.389.341,5.118.341,7.507a55.285,55.285,0,0,1-.341,7.507,55.8,55.8,0,0,1-.682,7.507,55.8,55.8,0,0,1-.682-7.507c0-2.389-.341-5.118-.341-7.507a55.285,55.285,0,0,1,.341-7.507A61.282,61.282,0,0,1,66.224,68.8Z"
						transform="translate(157.034 166.441)"
						fill="#341931"
					/>
					<path
						id="Path_488"
						data-name="Path 488"
						d="M67.024,66.4c.341,4.095.682,7.848.682,11.943s.341,7.848.341,11.943,0,7.848-.341,11.943c0,4.095-.341,7.848-.682,11.943-.341-4.095-.682-7.848-.682-11.943S66,94.38,66,90.285s0-7.848.341-11.943A68.167,68.167,0,0,1,67.024,66.4Z"
						transform="translate(158.964 160.652)"
						fill="#341931"
					/>
					<path
						id="Path_489"
						data-name="Path 489"
						d="M67.482,62.1c.341,6.483.682,12.625.682,19.108v38.217c0,6.483-.341,12.625-.682,19.108-.341-6.483-.682-12.625-.682-19.108V81.208C67.141,74.725,67.141,68.242,67.482,62.1Z"
						transform="translate(160.893 150.28)"
						fill="#341931"
					/>
					<path
						id="Path_490"
						data-name="Path 490"
						d="M68.282,59.2c.341,7.848.682,16.037.682,23.885v47.771c0,7.848-.341,16.037-.682,23.885-.341-7.848-.682-16.037-.682-23.885V83.085C67.6,75.237,67.941,67.389,68.282,59.2Z"
						transform="translate(162.823 143.284)"
						fill="#341931"
					/>
					<path
						id="Path_491"
						data-name="Path 491"
						d="M220.182,502.075c-.341-20.814-.341-41.97-.341-62.784l-.341-62.784V125.369l.341-62.784c0-20.814.341-41.97.341-62.784.341,20.814.341,41.97.341,62.784l.341,62.784V376.506l-.341,62.784C220.524,460.1,220.524,481.26,220.182,502.075Z"
						transform="translate(529.235)"
						fill="#341931"
					/>
					<path
						id="Path_492"
						data-name="Path 492"
						d="M219.482,457.909c-.341-18.767-.341-37.534-.341-56.3l-.341-56.3V120.1l.341-56.3c0-18.767.341-37.534.341-56.3.341,18.767.341,37.534.341,56.3l.341,56.3v225.2l-.341,56.3C219.824,420.375,219.482,439.142,219.482,457.909Z"
						transform="translate(527.547 18.574)"
						fill="#341931"
					/>
					<path
						id="Path_493"
						data-name="Path 493"
						d="M218.682,422.963c-.341-17.061-.341-34.122-.341-51.183L218,320.6V115.866l.341-51.183c0-17.061.341-34.122.341-51.183.341,17.061.341,34.122.341,51.183l.341,51.183V320.6l-.341,51.183C219.024,389.182,219.024,405.9,218.682,422.963Z"
						transform="translate(525.617 33.047)"
						fill="#341931"
					/>
					<path
						id="Path_494"
						data-name="Path 494"
						d="M218.124,389.864c-.341-15.355-.341-30.71-.341-46.406l-.341-46.406c0-30.71-.341-61.761-.341-92.47s0-61.761.341-92.47l.341-46.406c0-15.355.341-30.71.341-46.406.341,15.355.341,30.71.341,46.406l.341,46.406c0,30.71.341,61.761.341,92.47s0,61.761-.341,92.47l-.341,46.406C218.465,359.154,218.465,374.509,218.124,389.864Z"
						transform="translate(523.446 47.038)"
						fill="#341931"
					/>
					<path
						id="Path_495"
						data-name="Path 495"
						d="M217.182,409.285c-.341-16.379-.341-32.757-.341-49.136l-.341-49.136V114.471l.341-49.136c0-16.379.341-32.757.341-49.136.341,16.379.341,32.757.341,49.136l.341,49.136V311.013l-.341,49.136C217.524,376.528,217.182,392.906,217.182,409.285Z"
						transform="translate(521.999 39.56)"
						fill="#341931"
					/>
					<path
						id="Path_496"
						data-name="Path 496"
						d="M216.382,429.952c-.341-17.4-.341-34.8-.341-52.207l-.341-52.207V116.713l.341-52.207c0-17.4.341-34.8.341-52.207.341,17.4.341,34.8.341,52.207l.341,52.207V325.539l-.341,52.207C216.724,395.489,216.724,412.55,216.382,429.952Z"
						transform="translate(520.069 30.152)"
						fill="#341931"
					/>
					<path
						id="Path_497"
						data-name="Path 497"
						d="M215.582,413.944c-.341-16.72-.341-33.44-.341-49.818l-.341-49.818V115.036l.341-49.818c0-16.72.341-33.439.341-49.818.341,16.72.341,33.439.341,49.818l.341,49.818V314.308l-.341,49.818C215.924,380.846,215.924,397.224,215.582,413.944Z"
						transform="translate(518.139 37.63)"
						fill="#341931"
					/>
					<path
						id="Path_498"
						data-name="Path 498"
						d="M215.124,385.887c-.341-15.355-.341-30.369-.341-45.723l-.341-45.723c0-30.369-.341-61.078-.341-91.447s0-61.078.341-91.447l.341-45.723c0-15.355.341-30.369.341-45.723.341,15.355.341,30.369.341,45.723l.341,45.723c0,30.369.341,61.078.341,91.447s0,61.078-.341,91.447l-.341,45.723C215.465,355.519,215.124,370.532,215.124,385.887Z"
						transform="translate(516.209 48.968)"
						fill="#341931"
					/>
					<path
						id="Path_499"
						data-name="Path 499"
						d="M214.324,347.929c-.341-13.308-.341-26.615-.341-40.264l-.341-40.264c0-26.615-.341-53.571-.341-80.187s0-53.571.341-80.187l.341-40.264c0-13.308.341-26.615.341-40.264.341,13.308.341,26.615.341,40.264l.341,40.264c0,26.615.341,53.571.341,80.187s0,53.571-.341,80.187l-.341,40.264C214.665,321.313,214.665,334.621,214.324,347.929Z"
						transform="translate(514.279 64.406)"
						fill="#341931"
					/>
					<path
						id="Path_500"
						data-name="Path 500"
						d="M213.282,306.675c-.341-22.862-.682-45.382-.682-68.244V101.944c0-22.862.341-45.382.682-68.244.341,22.862.682,45.382.682,68.244V238.432C213.965,260.952,213.624,283.814,213.282,306.675Z"
						transform="translate(512.591 81.773)"
						fill="#341931"
					/>
					<path
						id="Path_501"
						data-name="Path 501"
						d="M212.582,273.959c-.341-19.449-.682-38.9-.682-58.69V97.89c0-19.45.341-38.9.682-58.69.341,19.45.682,38.9.682,58.69V215.269C212.924,235.06,212.924,254.509,212.582,273.959Z"
						transform="translate(510.902 95.04)"
						fill="#341931"
					/>
					<path
						id="Path_502"
						data-name="Path 502"
						d="M211.782,239.213c-.341-16.037-.682-32.416-.682-48.453V93.853c0-16.037.341-32.416.682-48.453.341,16.037.682,32.416.682,48.453v96.906C212.465,206.8,212.124,222.834,211.782,239.213Z"
						transform="translate(508.973 109.996)"
						fill="#341931"
					/>
					<path
						id="Path_503"
						data-name="Path 503"
						d="M210.982,258.333c-.341-18.085-.682-36.169-.682-54.254V96.254c0-18.085.341-36.169.682-54.254.341,18.085.682,36.169.682,54.254V204.079C211.665,222.164,211.324,240.248,210.982,258.333Z"
						transform="translate(507.043 101.795)"
						fill="#341931"
					/>
					<path
						id="Path_504"
						data-name="Path 504"
						d="M210.282,280.948c-.341-20.132-.682-40.264-.682-60.737V98.737c0-20.132.341-40.264.682-60.737.341,20.132.682,40.264.682,60.737V220.211C210.624,240.684,210.624,260.816,210.282,280.948Z"
						transform="translate(505.354 92.146)"
						fill="#341931"
					/>
					<path
						id="Path_505"
						data-name="Path 505"
						d="M209.482,306.675c-.341-22.862-.682-45.382-.682-68.244V101.944c0-22.862.341-45.382.682-68.244.341,22.862.682,45.382.682,68.244V238.432C210.165,260.952,209.824,283.814,209.482,306.675Z"
						transform="translate(503.425 81.773)"
						fill="#341931"
					/>
					<path
						id="Path_506"
						data-name="Path 506"
						d="M208.682,292.8c-.341-21.5-.682-42.994-.682-64.149v-128.3c0-21.5.341-42.994.682-64.149.341,21.5.682,42.994.682,64.149v128.3C209.365,249.8,209.024,271.3,208.682,292.8Z"
						transform="translate(501.495 87.804)"
						fill="#341931"
					/>
					<path
						id="Path_507"
						data-name="Path 507"
						d="M207.982,267.752c-.341-19.108-.682-37.875-.682-56.984V97.484c0-19.108.341-37.875.682-56.984.341,19.108.682,37.875.682,56.984V210.768C208.324,229.536,208.324,248.644,207.982,267.752Z"
						transform="translate(499.806 98.176)"
						fill="#341931"
					/>
					<path
						id="Path_508"
						data-name="Path 508"
						d="M207.182,250.761c-.341-17.4-.682-34.463-.682-51.865V95.165c0-17.4.341-34.463.682-51.865.341,17.4.682,34.463.682,51.865V198.9C207.865,215.957,207.524,233.359,207.182,250.761Z"
						transform="translate(497.877 104.93)"
						fill="#341931"
					/>
					<path
						id="Path_509"
						data-name="Path 509"
						d="M206.382,226.781c-.341-15.014-.682-29.686-.682-44.7V92c0-15.014.341-29.686.682-44.7.341,15.014.682,29.686.682,44.7v90.082C207.065,197.1,206.724,211.768,206.382,226.781Z"
						transform="translate(495.947 114.579)"
						fill="#341931"
					/>
					<path
						id="Path_510"
						data-name="Path 510"
						d="M205.682,200.089c-.341-12.284-.682-24.568-.682-37.193v-73.7c0-12.284.341-24.568.682-37.193.341,12.284.682,24.568.682,37.193v73.7C206.024,175.521,206.024,187.805,205.682,200.089Z"
						transform="translate(494.258 125.916)"
						fill="#341931"
					/>
					<path
						id="Path_511"
						data-name="Path 511"
						d="M204.882,162.813c-.341-8.872-.682-17.4-.682-26.274V84.674c0-8.872.341-17.4.682-26.274.341,8.872.682,17.4.682,26.274v51.865C205.565,145.411,205.224,154.283,204.882,162.813Z"
						transform="translate(492.329 141.354)"
						fill="#341931"
					/>
					<path
						id="Path_512"
						data-name="Path 512"
						d="M204.082,132.626c-.341-5.8-.682-11.6-.682-17.4V81.1c0-5.8.341-11.6.682-17.4.341,5.8.682,11.6.682,17.4v34.122C204.765,121.025,204.424,126.826,204.082,132.626Z"
						transform="translate(490.399 154.139)"
						fill="#341931"
					/>
					<path
						id="Path_513"
						data-name="Path 513"
						d="M203.624,114.371c-.341-4.095-.682-7.848-.682-11.943s-.341-7.848-.341-11.943,0-7.848.341-11.943c0-4.095.341-7.848.682-11.943.341,4.095.682,7.848.682,11.943s.341,7.848.341,11.943,0,7.848-.341,11.943S203.965,110.617,203.624,114.371Z"
						transform="translate(488.469 161.134)"
						fill="#341931"
					/>
					<path
						id="Path_514"
						data-name="Path 514"
						d="M202.824,99.427a55.792,55.792,0,0,1-.682-7.507c0-2.389-.341-5.118-.341-7.507a55.28,55.28,0,0,1,.341-7.507,55.8,55.8,0,0,1,.682-7.507,55.792,55.792,0,0,1,.682,7.507c0,2.389.341,5.118.341,7.507a55.28,55.28,0,0,1-.341,7.507A61.288,61.288,0,0,1,202.824,99.427Z"
						transform="translate(486.539 167.889)"
						fill="#341931"
					/>
					<path
						id="Path_515"
						data-name="Path 515"
						d="M202.024,114.371c-.341-4.095-.682-7.848-.682-11.943S201,94.58,201,90.485s0-7.848.341-11.943c0-4.095.341-7.848.682-11.943.341,4.095.682,7.848.682,11.943s.341,7.848.341,11.943,0,7.848-.341,11.943C202.706,106.523,202.365,110.617,202.024,114.371Z"
						transform="translate(484.61 161.134)"
						fill="#341931"
					/>
					<path
						id="Path_516"
						data-name="Path 516"
						d="M201.082,138.933c-.341-6.483-.682-12.625-.682-19.108V81.608c0-6.483.341-12.625.682-19.108.341,6.483.682,12.625.682,19.108v38.217C201.424,126.308,201.424,132.791,201.082,138.933Z"
						transform="translate(483.162 151.244)"
						fill="#341931"
					/>
					<path
						id="Path_517"
						data-name="Path 517"
						d="M200.282,155.341c-.341-7.848-.682-16.037-.682-23.885V83.685c0-7.848.341-16.037.682-23.885.341,7.848.682,16.037.682,23.885v47.771C200.965,139.3,200.624,147.152,200.282,155.341Z"
						transform="translate(481.232 144.732)"
						fill="#341931"
					/>
					<path
						id="Path_518"
						data-name="Path 518"
						d="M199.482,138.933c-.341-6.483-.682-12.625-.682-19.108V81.608c0-6.483.341-12.625.682-19.108.341,6.483.682,12.625.682,19.108v38.217C200.165,126.308,199.824,132.791,199.482,138.933Z"
						transform="translate(479.303 151.244)"
						fill="#341931"
					/>
					<path
						id="Path_519"
						data-name="Path 519"
						d="M199.024,114.371c-.341-4.095-.682-7.848-.682-11.943S198,94.58,198,90.485s0-7.848.341-11.943c0-4.095.341-7.848.682-11.943.341,4.095.682,7.848.682,11.943s.341,7.848.341,11.943,0,7.848-.341,11.943S199.365,110.617,199.024,114.371Z"
						transform="translate(477.373 161.134)"
						fill="#341931"
					/>
					<path
						id="Path_520"
						data-name="Path 520"
						d="M198.224,99.427a55.792,55.792,0,0,1-.682-7.507c0-2.389-.341-5.118-.341-7.507a55.28,55.28,0,0,1,.341-7.507,55.8,55.8,0,0,1,.682-7.507,55.792,55.792,0,0,1,.682,7.507c0,2.389.341,5.118.341,7.507a55.28,55.28,0,0,1-.341,7.507C198.565,94.309,198.565,96.7,198.224,99.427Z"
						transform="translate(475.443 167.889)"
						fill="#341931"
					/>
					<path
						id="Path_521"
						data-name="Path 521"
						d="M197.424,86.414a14.51,14.51,0,0,1-.682-3.753c0-1.365-.341-2.389-.341-3.753a14,14,0,0,1,.341-3.753,14.513,14.513,0,0,1,.682-3.753,14.513,14.513,0,0,1,.682,3.753c0,1.365.341,2.389.341,3.753a14,14,0,0,1-.341,3.753A12.268,12.268,0,0,1,197.424,86.414Z"
						transform="translate(473.513 172.713)"
						fill="#341931"
					/>
					<path
						id="Path_522"
						data-name="Path 522"
						d="M196.724,99.427a55.792,55.792,0,0,1-.682-7.507c0-2.389-.341-5.118-.341-7.507a55.28,55.28,0,0,1,.341-7.507,55.8,55.8,0,0,1,.682-7.507,55.792,55.792,0,0,1,.682,7.507c0,2.389.341,5.118.341,7.507a55.28,55.28,0,0,1-.341,7.507C197.065,94.309,197.065,96.7,196.724,99.427Z"
						transform="translate(471.825 167.889)"
						fill="#341931"
					/>
					<path
						id="Path_523"
						data-name="Path 523"
						d="M195.682,123.549c-.341-4.777-.682-9.9-.682-14.672V94.545c0-4.777,0-9.9.341-14.672,0-4.777.341-9.9.682-14.672.341,4.777.682,9.9.682,14.672s.341,9.9.341,14.672v14.331C196.024,113.653,196.024,118.43,195.682,123.549Z"
						transform="translate(470.136 157.757)"
						fill="#341931"
					/>
					<path
						id="Path_524"
						data-name="Path 524"
						d="M194.882,148.252c-.341-7.166-.682-14.672-.682-21.838V82.738c0-7.166.341-14.672.682-21.838.341,7.166.682,14.672.682,21.838v43.676C195.565,133.58,195.224,141.087,194.882,148.252Z"
						transform="translate(468.207 147.385)"
						fill="#341931"
					/>
					<path
						id="Path_525"
						data-name="Path 525"
						d="M194.082,200.089c-.341-12.284-.682-24.568-.682-37.193v-73.7c0-12.284.341-24.568.682-37.193.341,12.284.682,24.568.682,37.193v73.7C194.765,175.521,194.765,187.805,194.082,200.089Z"
						transform="translate(466.277 125.916)"
						fill="#341931"
					/>
					<path
						id="Path_526"
						data-name="Path 526"
						d="M193.382,262.41c-.341-18.426-.682-36.852-.682-55.278V96.578c0-18.426.341-36.852.682-55.278.341,18.426.682,36.852.682,55.278V207.133C193.724,225.558,193.724,243.984,193.382,262.41Z"
						transform="translate(464.588 100.106)"
						fill="#341931"
					/>
					<path
						id="Path_527"
						data-name="Path 527"
						d="M192.824,316.094c-.341-11.943-.341-23.544-.341-35.487l-.341-35.487c0-23.544-.341-47.429-.341-70.974s0-47.429.341-70.974l.341-35.487c0-11.943.341-23.544.341-35.487.341,11.943.341,23.544.341,35.487l.341,35.487c0,23.544.341,47.429.341,70.974s0,47.429-.341,70.974l-.341,35.487C193.165,292.209,193.165,304.152,192.824,316.094Z"
						transform="translate(462.417 78.155)"
						fill="#341931"
					/>
					<path
						id="Path_528"
						data-name="Path 528"
						d="M192.024,364.337c-.341-14.331-.341-28.321-.341-42.652l-.341-42.652c0-28.321-.341-56.642-.341-84.964s0-56.642.341-84.964l.341-42.652c0-14.331.341-28.321.341-42.652.341,14.331.341,28.321.341,42.652l.341,42.652c0,28.321.341,56.642.341,84.964s0,56.642-.341,84.964l-.341,42.652C192.365,336.016,192.365,350.006,192.024,364.337Z"
						transform="translate(460.488 57.893)"
						fill="#341931"
					/>
					<path
						id="Path_529"
						data-name="Path 529"
						d="M191.324,339.974c-.341-12.966-.341-25.933-.341-38.9l-.341-38.9c0-25.933-.341-52.207-.341-78.139s0-52.207.341-78.139l.341-38.9c0-12.966.341-25.933.341-38.9.341,12.966.341,25.933.341,38.9l.341,38.9c0,25.933.341,52.207.341,78.139s0,52.207-.341,78.139l-.341,38.9C191.665,313.7,191.324,327.008,191.324,339.974Z"
						transform="translate(458.799 68.265)"
						fill="#341931"
					/>
					<path
						id="Path_530"
						data-name="Path 530"
						d="M190.282,292.8c-.341-21.5-.682-42.994-.682-64.149v-128.3c0-21.5.341-42.994.682-64.149.341,21.5.682,42.994.682,64.149v128.3C190.965,249.8,190.624,271.3,190.282,292.8Z"
						transform="translate(457.111 87.804)"
						fill="#341931"
					/>
					<path
						id="Path_531"
						data-name="Path 531"
						d="M189.724,325.213c-.341-12.284-.341-24.568-.341-36.852l-.341-36.852c0-24.568-.341-49.136-.341-73.7s0-49.136.341-73.7l.341-36.852c0-12.284.341-24.568.341-36.852.341,12.284.341,24.568.341,36.852l.341,36.852c0,24.568.341,49.136.341,73.7s0,49.136-.341,73.7l-.341,36.852C190.065,300.646,190.065,312.93,189.724,325.213Z"
						transform="translate(454.94 73.813)"
						fill="#341931"
					/>
					<path
						id="Path_532"
						data-name="Path 532"
						d="M188.782,280.948c-.341-20.132-.682-40.264-.682-60.737V98.737c0-20.132.341-40.264.682-60.737.341,20.132.682,40.264.682,60.737V220.211C189.124,240.684,189.124,260.816,188.782,280.948Z"
						transform="translate(453.492 92.146)"
						fill="#341931"
					/>
					<path
						id="Path_533"
						data-name="Path 533"
						d="M187.982,239.213c-.341-16.037-.682-32.416-.682-48.453V93.853c0-16.037.341-32.416.682-48.453.341,16.037.682,32.416.682,48.453v96.906C188.665,206.8,188.324,222.834,187.982,239.213Z"
						transform="translate(451.563 109.996)"
						fill="#341931"
					/>
					<path
						id="Path_534"
						data-name="Path 534"
						d="M187.182,183.3c-.341-10.578-.682-21.5-.682-32.075V87.075c0-10.578.341-21.5.682-32.075.341,10.578.682,21.5.682,32.075v64.149C187.865,161.8,187.524,172.379,187.182,183.3Z"
						transform="translate(449.633 133.153)"
						fill="#341931"
					/>
					<path
						id="Path_535"
						data-name="Path 535"
						d="M186.482,226.781c-.341-15.014-.682-29.686-.682-44.7V92c0-15.014.341-29.686.682-44.7.341,15.014.682,29.686.682,44.7v90.082C186.824,197.1,186.824,211.768,186.482,226.781Z"
						transform="translate(447.944 114.579)"
						fill="#341931"
					/>
					<path
						id="Path_536"
						data-name="Path 536"
						d="M185.682,280.948c-.341-20.132-.682-40.264-.682-60.737V98.737c0-20.132.341-40.264.682-60.737.341,20.132.682,40.264.682,60.737V220.211C186.365,240.684,186.024,260.816,185.682,280.948Z"
						transform="translate(446.014 92.146)"
						fill="#341931"
					/>
					<path
						id="Path_537"
						data-name="Path 537"
						d="M184.882,226.781c-.341-15.014-.682-29.686-.682-44.7V92c0-15.014.341-29.686.682-44.7.341,15.014.682,29.686.682,44.7v90.082C185.565,197.1,185.224,211.768,184.882,226.781Z"
						transform="translate(444.085 114.579)"
						fill="#341931"
					/>
					<path
						id="Path_538"
						data-name="Path 538"
						d="M184.182,162.813c-.341-8.872-.682-17.4-.682-26.274V84.674c0-8.872.341-17.4.682-26.274.341,8.872.682,17.4.682,26.274v51.865C184.524,145.411,184.524,154.283,184.182,162.813Z"
						transform="translate(442.396 141.354)"
						fill="#341931"
					/>
					<path
						id="Path_539"
						data-name="Path 539"
						d="M183.382,123.549c-.341-4.777-.682-9.9-.682-14.672V94.545c0-4.777,0-9.9.341-14.672,0-4.777.341-9.9.682-14.672.341,4.777.682,9.9.682,14.672s.341,9.9.341,14.672v14.331C184.065,113.653,183.724,118.43,183.382,123.549Z"
						transform="translate(440.466 157.757)"
						fill="#341931"
					/>
					<path
						id="Path_540"
						data-name="Path 540"
						d="M182.824,99.427a55.792,55.792,0,0,1-.682-7.507c0-2.389-.341-5.118-.341-7.507a55.28,55.28,0,0,1,.341-7.507,55.8,55.8,0,0,1,.682-7.507,55.792,55.792,0,0,1,.682,7.507c0,2.389.341,5.118.341,7.507a55.29,55.29,0,0,1-.341,7.507A61.288,61.288,0,0,1,182.824,99.427Z"
						transform="translate(438.295 167.889)"
						fill="#341931"
					/>
					<path
						id="Path_541"
						data-name="Path 541"
						d="M181.882,118.789c-.341-4.436-.682-8.872-.682-13.308V92.515c0-4.436,0-8.872.341-13.308,0-4.436.341-8.872.682-13.308.341,4.436.682,8.872.682,13.308s.341,8.872.341,13.308v12.966C182.224,109.917,182.224,114.353,181.882,118.789Z"
						transform="translate(436.848 159.446)"
						fill="#341931"
					/>
					<path
						id="Path_542"
						data-name="Path 542"
						d="M181.082,155.341c-.341-7.848-.682-16.037-.682-23.885V83.685c0-7.848.341-16.037.682-23.885.341,7.848.682,16.037.682,23.885v47.771C181.765,139.3,181.424,147.152,181.082,155.341Z"
						transform="translate(434.918 144.732)"
						fill="#341931"
					/>
					<path
						id="Path_543"
						data-name="Path 543"
						d="M180.282,190.088c-.341-11.26-.682-22.52-.682-34.122V87.722c0-11.26.341-22.52.682-34.122.341,11.26.682,22.52.682,34.122v68.244C180.965,167.567,180.624,178.827,180.282,190.088Z"
						transform="translate(432.989 129.776)"
						fill="#341931"
					/>
					<path
						id="Path_544"
						data-name="Path 544"
						d="M179.582,169.8c-.341-9.554-.682-18.767-.682-28.321V85.521c0-9.554.341-18.767.682-28.321.341,9.554.682,18.767.682,28.321v55.96C179.924,151.035,179.924,160.589,179.582,169.8Z"
						transform="translate(431.3 138.46)"
						fill="#341931"
					/>
					<path
						id="Path_545"
						data-name="Path 545"
						d="M178.782,141.263c-.341-6.483-.682-13.308-.682-19.791V81.891c0-6.483.341-13.308.682-19.791.341,6.483.682,13.308.682,19.791v39.581C179.465,128.3,179.124,134.78,178.782,141.263Z"
						transform="translate(429.37 150.28)"
						fill="#341931"
					/>
					<path
						id="Path_546"
						data-name="Path 546"
						d="M177.982,118.789c-.341-4.436-.682-8.872-.682-13.308V92.515c0-4.436,0-8.872.341-13.308,0-4.436.341-8.872.682-13.308.341,4.436.682,8.872.682,13.308s.341,8.872.341,13.308v12.966C178.665,109.917,178.324,114.353,177.982,118.789Z"
						transform="translate(427.441 159.446)"
						fill="#341931"
					/>
					<path
						id="Path_547"
						data-name="Path 547"
						d="M177.524,104.087a84.008,84.008,0,0,1-.682-8.872c0-3.071-.341-6.142-.341-8.872a74.208,74.208,0,0,1,.341-8.872,72.055,72.055,0,0,1,.682-8.872,84.007,84.007,0,0,1,.682,8.872c0,3.071.341,6.142.341,8.872a74.208,74.208,0,0,1-.341,8.872C177.865,97.945,177.865,101.016,177.524,104.087Z"
						transform="translate(425.511 165.959)"
						fill="#341931"
					/>
					<path
						id="Path_548"
						data-name="Path 548"
						d="M176.724,93.5a33.615,33.615,0,0,1-.682-5.8c0-2.047-.341-3.753-.341-5.8a33.1,33.1,0,0,1,.341-5.8,33.621,33.621,0,0,1,.682-5.8,33.615,33.615,0,0,1,.682,5.8c0,2.047.341,3.753.341,5.8a33.108,33.108,0,0,1-.341,5.8A37.992,37.992,0,0,1,176.724,93.5Z"
						transform="translate(423.581 170.06)"
						fill="#341931"
					/>
					<path
						id="Path_549"
						data-name="Path 549"
						d="M151.882,55.4c.341,10.237.682,20.814.682,31.051v62.784c0,10.237-.341,20.814-.682,31.051-.341-10.237-.682-20.814-.682-31.051V86.451C151.541,76.214,151.541,65.978,151.882,55.4Z"
						transform="translate(364.482 134.118)"
						fill="#341931"
					/>
					<path
						id="Path_550"
						data-name="Path 550"
						d="M151.182,42c.341,18.085.682,36.169.682,54.254V204.079c0,18.085-.341,36.169-.682,54.254-.341-18.085-.682-36.169-.682-54.254V96.254C150.5,78.169,150.841,60.085,151.182,42Z"
						transform="translate(362.794 101.795)"
						fill="#341931"
					/>
					<path
						id="Path_551"
						data-name="Path 551"
						d="M150.624,25.9c.341,13.649.341,27.3.341,40.946l.341,40.946c0,27.3.341,54.254.341,81.551s0,54.254-.341,81.551l-.341,40.946c0,13.649-.341,27.3-.341,40.946-.341-13.649-.341-27.3-.341-40.946l-.341-40.946c0-27.3-.341-54.254-.341-81.551s0-54.254.341-81.551l.341-40.946C150.283,52.856,150.283,39.549,150.624,25.9Z"
						transform="translate(360.623 62.958)"
						fill="#341931"
					/>
					<path
						id="Path_552"
						data-name="Path 552"
						d="M149.582,15.2c.341,16.72.341,33.439.341,49.818l.341,49.818V314.108l-.341,49.818c0,16.72-.341,33.439-.341,49.818-.341-16.72-.341-33.44-.341-49.818l-.341-49.818V114.836l.341-49.818C149.582,48.3,149.582,31.579,149.582,15.2Z"
						transform="translate(358.934 37.148)"
						fill="#341931"
					/>
					<path
						id="Path_553"
						data-name="Path 553"
						d="M149.124,20.1c.341,15.355.341,30.369.341,45.723l.341,45.723c0,30.369.341,61.078.341,91.447s0,61.078-.341,91.447l-.341,45.723c0,15.355-.341,30.369-.341,45.723-.341-15.355-.341-30.369-.341-45.723l-.341-45.723c0-30.369-.341-61.078-.341-91.447s0-61.078.341-91.447l.341-45.723C148.783,50.469,148.783,35.114,149.124,20.1Z"
						transform="translate(357.004 48.968)"
						fill="#341931"
					/>
					<path
						id="Path_554"
						data-name="Path 554"
						d="M148.324,26.7c.341,13.308.341,26.615.341,40.264l.341,40.264c0,26.615.341,53.571.341,80.187s0,53.571-.341,80.187l-.341,40.264c0,13.308-.341,26.615-.341,40.264-.341-13.308-.341-26.615-.341-40.264l-.341-40.264c0-26.615-.341-53.571-.341-80.187s0-53.571.341-80.187l.341-40.264C147.982,53.315,147.982,40.008,148.324,26.7Z"
						transform="translate(355.075 64.888)"
						fill="#341931"
					/>
					<path
						id="Path_555"
						data-name="Path 555"
						d="M147.282,33.7c.341,22.862.682,45.382.682,68.244V238.432c0,22.862-.341,45.382-.682,68.244-.341-22.862-.682-45.382-.682-68.244V101.944C146.941,79.082,146.941,56.562,147.282,33.7Z"
						transform="translate(353.386 81.773)"
						fill="#341931"
					/>
					<path
						id="Path_556"
						data-name="Path 556"
						d="M146.582,39.3c.341,19.449.682,38.9.682,58.69V215.369c0,19.449-.341,38.9-.682,58.69-.341-19.449-.682-38.9-.682-58.69V97.99C145.9,78.54,146.241,59.091,146.582,39.3Z"
						transform="translate(351.698 95.282)"
						fill="#341931"
					/>
					<path
						id="Path_557"
						data-name="Path 557"
						d="M145.782,45.2c.341,16.037.682,32.416.682,48.453v96.906c0,16.037-.341,32.416-.682,48.453-.341-16.037-.682-32.416-.682-48.453V93.653C145.1,77.616,145.441,61.579,145.782,45.2Z"
						transform="translate(349.768 109.514)"
						fill="#341931"
					/>
					<path
						id="Path_558"
						data-name="Path 558"
						d="M144.982,42c.341,18.085.682,36.169.682,54.254V204.079c0,18.085-.341,36.169-.682,54.254-.341-18.085-.682-36.169-.682-54.254V96.254C144.641,78.169,144.641,60.085,144.982,42Z"
						transform="translate(347.838 101.795)"
						fill="#341931"
					/>
					<path
						id="Path_559"
						data-name="Path 559"
						d="M144.282,38.2c.341,20.132.682,40.264.682,60.737V220.411c0,20.132-.341,40.264-.682,60.737-.341-20.132-.682-40.264-.682-60.737V98.937C143.6,78.464,143.941,58.332,144.282,38.2Z"
						transform="translate(346.15 92.628)"
						fill="#341931"
					/>
					<path
						id="Path_560"
						data-name="Path 560"
						d="M143.482,33.7c.341,22.862.682,45.382.682,68.244V238.432c0,22.862-.341,45.382-.682,68.244-.341-22.862-.682-45.382-.682-68.244V101.944C142.8,79.082,143.141,56.562,143.482,33.7Z"
						transform="translate(344.22 81.773)"
						fill="#341931"
					/>
					<path
						id="Path_561"
						data-name="Path 561"
						d="M142.682,36c.341,21.5.682,42.994.682,64.149v128.3c0,21.5-.341,42.994-.682,64.149-.341-21.5-.682-42.994-.682-64.149v-128.3C142.341,78.994,142.341,57.5,142.682,36Z"
						transform="translate(342.29 87.321)"
						fill="#341931"
					/>
					<path
						id="Path_562"
						data-name="Path 562"
						d="M141.982,40.3c.341,19.108.682,37.875.682,56.984V210.568c0,19.108-.341,37.875-.682,56.984-.341-19.108-.682-37.875-.682-56.984V97.284C141.3,78.175,141.641,59.408,141.982,40.3Z"
						transform="translate(340.602 97.694)"
						fill="#341931"
					/>
					<path
						id="Path_563"
						data-name="Path 563"
						d="M141.182,43.3c.341,17.4.682,34.463.682,51.865V198.9c0,17.4-.341,34.463-.682,51.865-.341-17.4-.682-34.463-.682-51.865V95.165C140.5,77.763,140.841,60.7,141.182,43.3Z"
						transform="translate(338.672 104.93)"
						fill="#341931"
					/>
					<path
						id="Path_564"
						data-name="Path 564"
						d="M140.382,47.5c.341,15.014.682,29.686.682,44.7v90.082c0,15.014-.341,29.686-.682,44.7-.341-15.014-.682-29.686-.682-44.7V92.2C140.041,77.186,140.041,62.514,140.382,47.5Z"
						transform="translate(336.742 115.062)"
						fill="#341931"
					/>
					<path
						id="Path_565"
						data-name="Path 565"
						d="M139.682,51.9c.341,12.284.682,24.568.682,37.193v73.7c0,12.284-.341,24.568-.682,37.193-.341-12.284-.682-24.568-.682-37.193v-73.7C139,76.809,139.341,64.525,139.682,51.9Z"
						transform="translate(335.054 125.675)"
						fill="#341931"
					/>
					<path
						id="Path_566"
						data-name="Path 566"
						d="M138.882,58.4c.341,8.872.682,17.4.682,26.274v51.865c0,8.872-.341,17.4-.682,26.274-.341-8.872-.682-17.4-.682-26.274V84.674C138.2,75.8,138.541,66.93,138.882,58.4Z"
						transform="translate(333.124 141.355)"
						fill="#341931"
					/>
					<path
						id="Path_567"
						data-name="Path 567"
						d="M138.082,63.5c.341,5.8.682,11.6.682,17.4v34.122c0,5.8-.341,11.6-.682,17.4-.341-5.8-.682-11.6-.682-17.4V80.9C137.741,75.1,137.741,69.3,138.082,63.5Z"
						transform="translate(331.194 153.657)"
						fill="#341931"
					/>
					<path
						id="Path_568"
						data-name="Path 568"
						d="M137.624,66.7c.341,4.095.682,7.848.682,11.943s.341,7.848.341,11.943,0,7.848-.341,11.943c0,4.095-.341,7.848-.682,11.943-.341-4.095-.682-7.848-.682-11.943s-.341-7.848-.341-11.943,0-7.848.341-11.943C136.941,74.548,137.282,70.795,137.624,66.7Z"
						transform="translate(329.264 161.376)"
						fill="#341931"
					/>
					<path
						id="Path_569"
						data-name="Path 569"
						d="M136.824,69.2a55.8,55.8,0,0,1,.682,7.507c0,2.389.341,5.118.341,7.507a55.28,55.28,0,0,1-.341,7.507,55.8,55.8,0,0,1-.682,7.507,55.793,55.793,0,0,1-.682-7.507c0-2.389-.341-5.118-.341-7.507a55.28,55.28,0,0,1,.341-7.507A61.264,61.264,0,0,1,136.824,69.2Z"
						transform="translate(327.335 167.406)"
						fill="#341931"
					/>
					<path
						id="Path_570"
						data-name="Path 570"
						d="M136.024,66.7c.341,4.095.682,7.848.682,11.943s.341,7.848.341,11.943,0,7.848-.341,11.943c0,4.095-.341,7.848-.682,11.943-.341-4.095-.682-7.848-.682-11.943S135,94.68,135,90.585s0-7.848.341-11.943S135.682,70.795,136.024,66.7Z"
						transform="translate(325.405 161.376)"
						fill="#341931"
					/>
					<path
						id="Path_571"
						data-name="Path 571"
						d="M135.082,62.4c.341,6.483.682,12.625.682,19.108v38.217c0,6.483-.341,12.625-.682,19.108-.341-6.483-.682-12.625-.682-19.108V81.508C134.4,75.366,134.741,68.883,135.082,62.4Z"
						transform="translate(323.958 151.003)"
						fill="#341931"
					/>
					<path
						id="Path_572"
						data-name="Path 572"
						d="M134.282,59.6c.341,7.848.682,16.037.682,23.885v47.771c0,7.848-.341,16.037-.682,23.885-.341-7.848-.682-16.037-.682-23.885V83.485C133.6,75.637,133.941,67.448,134.282,59.6Z"
						transform="translate(322.028 144.249)"
						fill="#341931"
					/>
					<path
						id="Path_573"
						data-name="Path 573"
						d="M133.482,62.4c.341,6.483.682,12.625.682,19.108v38.217c0,6.483-.341,12.625-.682,19.108-.341-6.483-.682-12.625-.682-19.108V81.508C133.141,75.366,133.141,68.883,133.482,62.4Z"
						transform="translate(320.098 151.003)"
						fill="#341931"
					/>
					<path
						id="Path_574"
						data-name="Path 574"
						d="M133.024,66.7c.341,4.095.682,7.848.682,11.943s.341,7.848.341,11.943,0,7.848-.341,11.943c0,4.095-.341,7.848-.682,11.943-.341-4.095-.682-7.848-.682-11.943S132,94.68,132,90.585s0-7.848.341-11.943A70.138,70.138,0,0,1,133.024,66.7Z"
						transform="translate(318.168 161.376)"
						fill="#341931"
					/>
					<path
						id="Path_575"
						data-name="Path 575"
						d="M132.224,69.2a55.8,55.8,0,0,1,.682,7.507c0,2.389.341,5.118.341,7.507a55.28,55.28,0,0,1-.341,7.507,55.8,55.8,0,0,1-.682,7.507,55.793,55.793,0,0,1-.682-7.507c0-2.389-.341-5.118-.341-7.507a55.28,55.28,0,0,1,.341-7.507A61.276,61.276,0,0,1,132.224,69.2Z"
						transform="translate(316.238 167.406)"
						fill="#341931"
					/>
					<path
						id="Path_576"
						data-name="Path 576"
						d="M131.424,71.5a14.511,14.511,0,0,1,.682,3.753c0,1.365.341,2.389.341,3.753a14,14,0,0,1-.341,3.753,14.513,14.513,0,0,1-.682,3.753,14.51,14.51,0,0,1-.682-3.753c0-1.365-.341-2.389-.341-3.753a14,14,0,0,1,.341-3.753C131.082,74.23,131.082,72.865,131.424,71.5Z"
						transform="translate(314.309 172.954)"
						fill="#341931"
					/>
					<path
						id="Path_577"
						data-name="Path 577"
						d="M130.724,69.2a55.792,55.792,0,0,1,.682,7.507c0,2.389.341,5.118.341,7.507a55.28,55.28,0,0,1-.341,7.507,55.8,55.8,0,0,1-.682,7.507,55.8,55.8,0,0,1-.682-7.507c0-2.389-.341-5.118-.341-7.507a55.28,55.28,0,0,1,.341-7.507A29.271,29.271,0,0,1,130.724,69.2Z"
						transform="translate(312.62 167.406)"
						fill="#341931"
					/>
					<path
						id="Path_578"
						data-name="Path 578"
						d="M130.165,65.1c.341,4.777.682,9.9.682,14.672V94.1c0,4.777,0,9.9-.341,14.672,0,4.777-.341,9.9-.682,14.672-.341-4.777-.682-9.9-.682-14.672s-.341-9.9-.341-14.672V79.772C129.482,75,129.824,69.877,130.165,65.1Z"
						transform="translate(310.449 157.516)"
						fill="#341931"
					/>
					<path
						id="Path_579"
						data-name="Path 579"
						d="M128.882,60.8c.341,7.166.682,14.672.682,21.838v43.676c0,7.166-.341,14.672-.682,21.838-.341-7.166-.682-14.672-.682-21.838V82.638C128.541,75.472,128.541,68.307,128.882,60.8Z"
						transform="translate(309.002 147.144)"
						fill="#341931"
					/>
					<path
						id="Path_580"
						data-name="Path 580"
						d="M128.182,51.9c.341,12.284.682,24.568.682,37.193v73.7c0,12.284-.341,24.568-.682,37.193-.341-12.284-.682-24.568-.682-37.193v-73.7C127.5,76.809,127.5,64.525,128.182,51.9Z"
						transform="translate(307.313 125.675)"
						fill="#341931"
					/>
					<path
						id="Path_581"
						data-name="Path 581"
						d="M127.382,41.3c.341,18.426.682,36.852.682,55.278V207.133c0,18.426-.341,36.852-.682,55.278-.341-18.426-.682-36.852-.682-55.278V96.578C126.7,78.152,127.041,59.726,127.382,41.3Z"
						transform="translate(305.384 100.106)"
						fill="#341931"
					/>
					<path
						id="Path_582"
						data-name="Path 582"
						d="M126.582,44c.341,16.72.682,33.781.682,50.5v101c0,16.72-.341,33.781-.682,50.5-.341-16.72-.682-33.781-.682-50.5V94.5C125.9,77.781,126.241,60.72,126.582,44Z"
						transform="translate(303.454 106.619)"
						fill="#341931"
					/>
					<path
						id="Path_583"
						data-name="Path 583"
						d="M125.782,38.2c.341,20.132.682,40.264.682,60.737V220.411c0,20.132-.341,40.264-.682,60.737-.341-20.132-.682-40.264-.682-60.737V98.937C125.441,78.464,125.441,58.332,125.782,38.2Z"
						transform="translate(301.524 92.628)"
						fill="#341931"
					/>
					<path
						id="Path_584"
						data-name="Path 584"
						d="M125.082,41.1c.341,18.426.682,37.193.682,55.619v111.92c0,18.426-.341,37.193-.682,55.619-.341-18.426-.682-37.193-.682-55.619V96.719C124.4,77.952,124.741,59.526,125.082,41.1Z"
						transform="translate(299.836 99.624)"
						fill="#341931"
					/>
					<path
						id="Path_585"
						data-name="Path 585"
						d="M124.282,36c.341,21.5.682,42.994.682,64.149v128.3c0,21.5-.341,42.994-.682,64.149-.341-21.5-.682-42.994-.682-64.149v-128.3C123.6,78.994,123.941,57.5,124.282,36Z"
						transform="translate(297.906 87.321)"
						fill="#341931"
					/>
					<path
						id="Path_586"
						data-name="Path 586"
						d="M123.724,32.8c.341,11.6.341,23.2.341,34.8l.341,34.8c0,23.2.341,46.406.341,69.609s0,46.406-.341,69.609l-.341,34.8c0,11.6-.341,23.2-.341,34.8-.341-11.6-.341-23.2-.341-34.8l-.341-34.8c0-23.2-.341-46.406-.341-69.609s0-46.406.341-69.609l.341-34.8C123.724,56,123.724,44.4,123.724,32.8Z"
						transform="translate(295.735 79.602)"
						fill="#341931"
					/>
					<path
						id="Path_587"
						data-name="Path 587"
						d="M122.782,38.2c.341,20.132.682,40.264.682,60.737V220.411c0,20.132-.341,40.264-.682,60.737-.341-20.132-.682-40.264-.682-60.737V98.937C122.1,78.464,122.441,58.332,122.782,38.2Z"
						transform="translate(294.288 92.628)"
						fill="#341931"
					/>
					<path
						id="Path_588"
						data-name="Path 588"
						d="M121.982,45.2c.341,16.037.682,32.416.682,48.453v96.906c0,16.037-.341,32.416-.682,48.453-.341-16.037-.682-32.416-.682-48.453V93.653C121.3,77.616,121.641,61.579,121.982,45.2Z"
						transform="translate(292.358 109.514)"
						fill="#341931"
					/>
					<path
						id="Path_589"
						data-name="Path 589"
						d="M121.182,54.8c.341,10.578.682,21.5.682,32.075v64.149c0,10.578-.341,21.5-.682,32.075-.341-10.578-.682-21.5-.682-32.075V86.875C120.841,76.3,120.841,65.378,121.182,54.8Z"
						transform="translate(290.428 132.671)"
						fill="#341931"
					/>
					<path
						id="Path_590"
						data-name="Path 590"
						d="M120.482,50.3c.341,13.308.682,26.615.682,39.923v79.163c0,13.308-.341,26.615-.682,39.923-.341-13.308-.682-26.615-.682-39.923V90.223C119.8,76.915,120.141,63.608,120.482,50.3Z"
						transform="translate(288.74 121.816)"
						fill="#341931"
					/>
					<path
						id="Path_591"
						data-name="Path 591"
						d="M119.682,44.8c.341,16.379.682,32.757.682,49.136v98.271c0,16.379-.341,32.757-.682,49.136-.341-16.379-.682-32.757-.682-49.136V93.936C119,77.9,119.341,61.52,119.682,44.8Z"
						transform="translate(286.81 108.549)"
						fill="#341931"
					/>
					<path
						id="Path_592"
						data-name="Path 592"
						d="M118.882,50.3c.341,13.308.682,26.615.682,39.923v79.163c0,13.308-.341,26.615-.682,39.923-.341-13.308-.682-26.615-.682-39.923V90.223C118.541,76.915,118.541,63.608,118.882,50.3Z"
						transform="translate(284.88 121.816)"
						fill="#341931"
					/>
					<path
						id="Path_593"
						data-name="Path 593"
						d="M118.182,58.4c.341,8.872.682,17.4.682,26.274v51.865c0,8.872-.341,17.4-.682,26.274-.341-8.872-.682-17.4-.682-26.274V84.674C117.5,75.8,117.841,66.93,118.182,58.4Z"
						transform="translate(283.191 141.355)"
						fill="#341931"
					/>
					<path
						id="Path_594"
						data-name="Path 594"
						d="M117.865,65.1c.341,4.777.682,9.9.682,14.672V94.1c0,4.777,0,9.9-.341,14.672,0,4.777-.341,9.9-.682,14.672-.341-4.777-.682-9.9-.682-14.672s-.341-9.9-.341-14.672V79.772C117.182,75,117.524,69.877,117.865,65.1Z"
						transform="translate(280.779 157.516)"
						fill="#341931"
					/>
					<path
						id="Path_595"
						data-name="Path 595"
						d="M116.824,69.2a55.8,55.8,0,0,1,.682,7.507c0,2.389.341,5.118.341,7.507a55.285,55.285,0,0,1-.341,7.507,55.8,55.8,0,0,1-.682,7.507,55.8,55.8,0,0,1-.682-7.507c0-2.389-.341-5.118-.341-7.507a55.285,55.285,0,0,1,.341-7.507C116.482,74.318,116.482,71.93,116.824,69.2Z"
						transform="translate(279.091 167.406)"
						fill="#341931"
					/>
					<path
						id="Path_596"
						data-name="Path 596"
						d="M116.365,66c.341,4.436.682,8.872.682,13.308V92.274c0,4.436,0,8.872-.341,13.308,0,4.436-.341,8.872-.682,13.308-.341-4.436-.682-8.872-.682-13.308S115,96.71,115,92.274V79.308C115.682,74.53,116.024,70.095,116.365,66Z"
						transform="translate(277.161 159.687)"
						fill="#341931"
					/>
					<path
						id="Path_597"
						data-name="Path 597"
						d="M115.082,62c.341,6.483.682,13.308.682,19.791v39.581c0,6.483-.341,13.308-.682,19.791-.341-6.483-.682-13.308-.682-19.791V81.791C114.4,75.308,114.741,68.483,115.082,62Z"
						transform="translate(275.714 150.038)"
						fill="#341931"
					/>
					<path
						id="Path_598"
						data-name="Path 598"
						d="M114.282,58.4c.341,8.872.682,17.4.682,26.274v51.865c0,8.872-.341,17.4-.682,26.274-.341-8.872-.682-17.4-.682-26.274V84.674C113.941,75.8,113.941,66.93,114.282,58.4Z"
						transform="translate(273.784 141.355)"
						fill="#341931"
					/>
					<path
						id="Path_599"
						data-name="Path 599"
						d="M113.582,61c.341,7.166.682,14.331.682,21.838v43.676c0,7.166-.341,14.331-.682,21.838-.341-7.166-.682-14.331-.682-21.838V82.838C112.9,75.331,113.241,68.166,113.582,61Z"
						transform="translate(272.095 147.626)"
						fill="#341931"
					/>
					<path
						id="Path_600"
						data-name="Path 600"
						d="M112.782,64c.341,5.46.682,10.919.682,16.379v32.757c0,5.46-.341,10.919-.682,16.379-.341-5.46-.682-10.919-.682-16.379V80.379C112.1,74.919,112.441,69.46,112.782,64Z"
						transform="translate(270.166 154.863)"
						fill="#341931"
					/>
					<path
						id="Path_601"
						data-name="Path 601"
						d="M112.465,66c.341,4.436.682,8.872.682,13.308V92.274c0,4.436,0,8.872-.341,13.308,0,4.436-.341,8.872-.682,13.308-.341-4.436-.682-8.872-.682-13.308s-.341-8.872-.341-13.308V79.308C112.124,74.53,112.124,70.095,112.465,66Z"
						transform="translate(267.753 159.687)"
						fill="#341931"
					/>
					<path
						id="Path_602"
						data-name="Path 602"
						d="M111.524,68.4a84.015,84.015,0,0,1,.682,8.872c0,3.071.341,6.142.341,8.872a74.221,74.221,0,0,1-.341,8.872,72.049,72.049,0,0,1-.682,8.872,84.015,84.015,0,0,1-.682-8.872c0-3.071-.341-6.142-.341-8.872a74.215,74.215,0,0,1,.341-8.872A84,84,0,0,1,111.524,68.4Z"
						transform="translate(266.306 165.476)"
						fill="#341931"
					/>
					<path
						id="Path_603"
						data-name="Path 603"
						d="M110.724,70.3a33.618,33.618,0,0,1,.682,5.8c0,2.047.341,3.753.341,5.8a33.108,33.108,0,0,1-.341,5.8,33.619,33.619,0,0,1-.682,5.8,33.619,33.619,0,0,1-.682-5.8c0-2.047-.341-3.753-.341-5.8a33.1,33.1,0,0,1,.341-5.8A33.618,33.618,0,0,1,110.724,70.3Z"
						transform="translate(264.376 170.06)"
						fill="#341931"
					/>
					<path
						id="Path_604"
						data-name="Path 604"
						d="M175.682,129.032c-.341-5.46-.682-10.919-.682-16.037V80.237c0-5.46.341-10.919.682-16.037.341,5.46.682,10.919.682,16.037v32.757C176.365,118.113,176.024,123.572,175.682,129.032Z"
						transform="translate(421.893 155.345)"
						fill="#341931"
					/>
					<path
						id="Path_605"
						data-name="Path 605"
						d="M174.982,162.813c-.341-8.872-.682-17.4-.682-26.274V84.674c0-8.872.341-17.4.682-26.274.341,8.872.682,17.4.682,26.274v51.865C175.324,145.411,175.324,154.283,174.982,162.813Z"
						transform="translate(420.204 141.354)"
						fill="#341931"
					/>
					<path
						id="Path_606"
						data-name="Path 606"
						d="M174.182,185.528c-.341-10.919-.682-21.838-.682-32.757V87.257c0-10.919.341-21.838.682-32.757.341,10.919.682,21.838.682,32.757v65.514C174.865,163.69,174.524,174.609,174.182,185.528Z"
						transform="translate(418.274 131.947)"
						fill="#341931"
					/>
					<path
						id="Path_607"
						data-name="Path 607"
						d="M173.382,212.9c-.341-13.649-.682-27.3-.682-40.605V90.405c0-13.649.341-27.3.682-40.605.341,13.649.682,27.3.682,40.605V172.3C174.065,185.605,173.724,199.254,173.382,212.9Z"
						transform="translate(416.344 120.61)"
						fill="#341931"
					/>
					<path
						id="Path_608"
						data-name="Path 608"
						d="M172.682,180.186c-.341-10.237-.682-20.814-.682-31.051V86.351c0-10.237.341-20.814.682-31.051.341,10.237.682,20.814.682,31.051v62.784C173.024,159.713,173.024,169.95,172.682,180.186Z"
						transform="translate(414.656 133.877)"
						fill="#341931"
					/>
					<path
						id="Path_609"
						data-name="Path 609"
						d="M171.882,146.5c-.341-7.166-.682-14.331-.682-21.5V82.7c0-7.166.341-14.331.682-21.5.341,7.166.682,14.331.682,21.5v42.311C172.565,132.174,172.224,139.339,171.882,146.5Z"
						transform="translate(412.726 148.109)"
						fill="#341931"
					/>
					<path
						id="Path_610"
						data-name="Path 610"
						d="M171.082,120.3c-.341-4.436-.682-9.213-.682-13.649V93c0-4.436,0-9.213.341-13.649,0-4.436.341-9.213.682-13.649.341,4.436.682,9.213.682,13.649s.341,9.213.341,13.649v13.649C171.765,111.082,171.424,115.859,171.082,120.3Z"
						transform="translate(410.796 158.964)"
						fill="#341931"
					/>
					<path
						id="Path_611"
						data-name="Path 611"
						d="M170.624,114.371c-.341-4.095-.682-7.848-.682-11.943s-.341-7.848-.341-11.943,0-7.848.341-11.943c0-4.095.341-7.848.682-11.943.341,4.095.682,7.848.682,11.943s.341,7.848.341,11.943,0,7.848-.341,11.943S170.965,110.617,170.624,114.371Z"
						transform="translate(408.867 161.134)"
						fill="#341931"
					/>
					<path
						id="Path_612"
						data-name="Path 612"
						d="M169.582,138.933c-.341-6.483-.682-12.625-.682-19.108V81.608c0-6.483.341-12.625.682-19.108.341,6.483.682,12.625.682,19.108v38.217C170.265,126.308,169.924,132.791,169.582,138.933Z"
						transform="translate(407.178 151.244)"
						fill="#341931"
					/>
					<path
						id="Path_613"
						data-name="Path 613"
						d="M168.782,155.341c-.341-7.848-.682-16.037-.682-23.885V83.685c0-7.848.341-16.037.682-23.885.341,7.848.682,16.037.682,23.885v47.771C169.465,139.3,169.124,147.152,168.782,155.341Z"
						transform="translate(405.248 144.732)"
						fill="#341931"
					/>
					<path
						id="Path_614"
						data-name="Path 614"
						d="M168.082,138.933c-.341-6.483-.682-12.625-.682-19.108V81.608c0-6.483.341-12.625.682-19.108.341,6.483.682,12.625.682,19.108v38.217C168.424,126.308,168.424,132.791,168.082,138.933Z"
						transform="translate(403.56 151.244)"
						fill="#341931"
					/>
					<path
						id="Path_615"
						data-name="Path 615"
						d="M167.524,114.371c-.341-4.095-.682-7.848-.682-11.943s-.341-7.848-.341-11.943,0-7.848.341-11.943c0-4.095.341-7.848.682-11.943.341,4.095.682,7.848.682,11.943s.341,7.848.341,11.943,0,7.848-.341,11.943C168.206,106.523,167.865,110.617,167.524,114.371Z"
						transform="translate(401.389 161.134)"
						fill="#341931"
					/>
					<path
						id="Path_616"
						data-name="Path 616"
						d="M166.482,130.2c-.341-5.46-.682-10.919-.682-16.72V80.72c0-5.46.341-10.919.682-16.72.341,5.46.682,10.919.682,16.72v32.757C167.165,119.278,166.824,124.737,166.482,130.2Z"
						transform="translate(399.7 154.863)"
						fill="#341931"
					/>
					<path
						id="Path_617"
						data-name="Path 617"
						d="M165.782,162.813c-.341-8.872-.682-17.4-.682-26.274V84.674c0-8.872.341-17.4.682-26.274.341,8.872.682,17.4.682,26.274v51.865C166.124,145.411,166.124,154.283,165.782,162.813Z"
						transform="translate(398.012 141.354)"
						fill="#341931"
					/>
					<path
						id="Path_618"
						data-name="Path 618"
						d="M164.982,194.947c-.341-11.943-.682-23.885-.682-35.487V88.487c0-11.943.341-23.885.682-35.487.341,11.943.682,23.885.682,35.487V159.46C165.665,171.062,165.324,183,164.982,194.947Z"
						transform="translate(396.082 128.329)"
						fill="#341931"
					/>
					<path
						id="Path_619"
						data-name="Path 619"
						d="M164.182,239.213c-.341-16.037-.682-32.416-.682-48.453V93.853c0-16.037.341-32.416.682-48.453.341,16.037.682,32.416.682,48.453v96.906C164.865,206.8,164.524,222.834,164.182,239.213Z"
						transform="translate(394.152 109.996)"
						fill="#341931"
					/>
					<path
						id="Path_620"
						data-name="Path 620"
						d="M163.482,258.333c-.341-18.085-.682-36.169-.682-54.254V96.254c0-18.085.341-36.169.682-54.254.341,18.085.682,36.169.682,54.254V204.079C163.824,222.164,163.824,240.248,163.482,258.333Z"
						transform="translate(392.464 101.795)"
						fill="#341931"
					/>
					<path
						id="Path_621"
						data-name="Path 621"
						d="M162.682,280.948c-.341-20.132-.682-40.264-.682-60.737V98.737c0-20.132.341-40.264.682-60.737.341,20.132.682,40.264.682,60.737V220.211C163.365,240.684,163.024,260.816,162.682,280.948Z"
						transform="translate(390.534 92.146)"
						fill="#341931"
					/>
					<path
						id="Path_622"
						data-name="Path 622"
						d="M161.882,306.675c-.341-22.862-.682-45.382-.682-68.244V101.944c0-22.862.341-45.382.682-68.244.341,22.862.682,45.382.682,68.244V238.432C162.565,260.952,162.224,283.814,161.882,306.675Z"
						transform="translate(388.604 81.773)"
						fill="#341931"
					/>
					<path
						id="Path_623"
						data-name="Path 623"
						d="M161.182,292.8c-.341-21.5-.682-42.994-.682-64.149v-128.3c0-21.5.341-42.994.682-64.149.341,21.5.682,42.994.682,64.149v128.3C161.524,249.8,161.524,271.3,161.182,292.8Z"
						transform="translate(386.916 87.804)"
						fill="#341931"
					/>
					<path
						id="Path_624"
						data-name="Path 624"
						d="M160.382,267.752c-.341-19.108-.682-37.875-.682-56.984V97.484c0-19.108.341-37.875.682-56.984.341,19.108.682,37.875.682,56.984V210.768C160.724,229.536,160.724,248.644,160.382,267.752Z"
						transform="translate(384.986 98.176)"
						fill="#341931"
					/>
					<path
						id="Path_625"
						data-name="Path 625"
						d="M159.582,250.761c-.341-17.4-.682-34.463-.682-51.865V95.165c0-17.4.341-34.463.682-51.865.341,17.4.682,34.463.682,51.865V198.9C160.265,215.957,159.924,233.359,159.582,250.761Z"
						transform="translate(383.056 104.93)"
						fill="#341931"
					/>
					<path
						id="Path_626"
						data-name="Path 626"
						d="M158.782,226.781c-.341-15.014-.682-29.686-.682-44.7V92c0-15.014.341-29.686.682-44.7.341,15.014.682,29.686.682,44.7v90.082C159.465,197.1,159.124,211.768,158.782,226.781Z"
						transform="translate(381.126 114.579)"
						fill="#341931"
					/>
					<path
						id="Path_627"
						data-name="Path 627"
						d="M158.082,200.089c-.341-12.284-.682-24.568-.682-37.193v-73.7c0-12.284.341-24.568.682-37.193.341,12.284.682,24.568.682,37.193v73.7C158.424,175.521,158.424,187.805,158.082,200.089Z"
						transform="translate(379.438 125.916)"
						fill="#341931"
					/>
					<path
						id="Path_628"
						data-name="Path 628"
						d="M157.282,162.813c-.341-8.872-.682-17.4-.682-26.274V84.674c0-8.872.341-17.4.682-26.274.341,8.872.682,17.4.682,26.274v51.865C157.965,145.411,157.624,154.283,157.282,162.813Z"
						transform="translate(377.508 141.354)"
						fill="#341931"
					/>
					<path
						id="Path_629"
						data-name="Path 629"
						d="M156.482,132.626c-.341-5.8-.682-11.6-.682-17.4V81.1c0-5.8.341-11.6.682-17.4.341,5.8.682,11.6.682,17.4v34.122A148.389,148.389,0,0,1,156.482,132.626Z"
						transform="translate(375.578 154.139)"
						fill="#341931"
					/>
					<path
						id="Path_630"
						data-name="Path 630"
						d="M156.024,114.371c-.341-4.095-.682-7.848-.682-11.943S155,94.58,155,90.485s0-7.848.341-11.943c0-4.095.341-7.848.682-11.943.341,4.095.682,7.848.682,11.943s.341,7.848.341,11.943,0,7.848-.341,11.943S156.365,110.617,156.024,114.371Z"
						transform="translate(373.649 161.134)"
						fill="#341931"
					/>
					<path
						id="Path_631"
						data-name="Path 631"
						d="M155.224,99.427a55.792,55.792,0,0,1-.682-7.507c0-2.389-.341-5.118-.341-7.507a55.28,55.28,0,0,1,.341-7.507,55.8,55.8,0,0,1,.682-7.507,55.792,55.792,0,0,1,.682,7.507c0,2.389.341,5.118.341,7.507a55.28,55.28,0,0,1-.341,7.507A61.276,61.276,0,0,1,155.224,99.427Z"
						transform="translate(371.719 167.889)"
						fill="#341931"
					/>
					<path
						id="Path_632"
						data-name="Path 632"
						d="M154.424,114.371c-.341-4.095-.682-7.848-.682-11.943s-.341-7.848-.341-11.943,0-7.848.341-11.943c0-4.095.341-7.848.682-11.943.341,4.095.682,7.848.682,11.943s.341,7.848.341,11.943,0,7.848-.341,11.943A68.17,68.17,0,0,1,154.424,114.371Z"
						transform="translate(369.789 161.134)"
						fill="#341931"
					/>
					<path
						id="Path_633"
						data-name="Path 633"
						d="M153.482,138.933c-.341-6.483-.682-12.625-.682-19.108V81.608c0-6.483.341-12.625.682-19.108.341,6.483.682,12.625.682,19.108v38.217C153.824,126.308,153.824,132.791,153.482,138.933Z"
						transform="translate(368.342 151.244)"
						fill="#341931"
					/>
					<path
						id="Path_634"
						data-name="Path 634"
						d="M152.682,155.341c-.341-7.848-.682-16.037-.682-23.885V83.685c0-7.848.341-16.037.682-23.885.341,7.848.682,16.037.682,23.885v47.771C153.365,139.3,153.024,147.152,152.682,155.341Z"
						transform="translate(366.412 144.732)"
						fill="#341931"
					/>
				</g>
			</svg>
			<section css={playerInfo} key={player.id}>
				<p css={playerName}>{player.name}</p>
				<p css={playerArtist}>{player.artists[0].name}</p>
			</section>
			<svg width="0" height="0">
				<linearGradient id="pinkish-gradient" x1="100%" y1="100%" x2="0%" y2="0%">
					<stop stopColor="#ee0979" offset="0%" />
					<stop stopColor="#ff6a00" offset="100%" />
				</linearGradient>
			</svg>
			<AudioPlayer
				css={audioPlayer}
				autoPlay
				src="/pleasantporridge.mp3"
				onPlay={(e) => console.log('onPlay')}
				customIcons={{
					play: <IoIosPlayCircle style={{ fill: 'url(#pinkish-gradient)' }} />,
					pause: <IoIosPause style={{ fill: 'url(#pinkish-gradient)' }} />,
					rewind: <IoIosRewind style={{ color: theme.text }} />,
					forward: <IoIosFastforward style={{ color: theme.text }} />,
					loop: <TiArrowLoop style={{ fill: 'url(#pinkish-gradient)' }} />,
					loopOff: <TiArrowLoop style={{ color: theme.text }} />,
					volume: <ImVolumeHigh style={{ fill: 'url(#pinkish-gradient)' }} />,
					volumeMute: <HiVolumeOff style={{ fill: 'url(#pinkish-gradient)' }} />,
				}}
			/>
		</>
	);
};

export default PlayerElement;
